import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, TemplateRef, ViewChild, OnDestroy, Inject, Optional } from '@angular/core';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Location, DatePipe } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UsersService } from 'src/app/services/users.service';
import { LeadService } from 'src/app/services/lead.service';
import { CrmNoteService } from 'src/app/services/crm-note.service';
import { ConversationPopupComponent } from 'src/app/shared/conversation-popup/conversation-popup.component';
import { Constant } from 'src/app/constant/constant';
import { CrmNoteComponent } from 'src/app/shared/crm-note/crm-note.component';
import { CallListComponent } from 'src/app/shared/call-list/call-list.component';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ProductService } from 'src/app/services/product.service';
import { downloads, ResourceAccess } from 'src/app/shared/utils/calsoft-validators';
import { DynamicFormLabelService } from 'src/app/services/dynamic-form-label.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { LoaderService } from 'src/app/services/loader.service';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { EmailSendService } from 'src/app/services/email-send.service';
import { MailBoxService } from 'src/app/services/mail-box.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { DealActivityService } from 'src/app/services/deal-activity.service';
import { SimpleDynamicFormComponent } from 'src/app/shared/simple-form/simple-dynamic-form/simple-dynamic-form.component';
import { DealsService } from 'src/app/services/deals.service';
import { GoogleCalendarServiceAccountService } from 'src/app/services/google-calendar-service-account.service';
import { CommonService } from 'src/app/services/common.service';
import { DownloadImageService } from 'src/app/services/download-image.service';
import { TagesStatusService } from 'src/app/services/tages-status.service';
import { PopupEditComponent } from 'src/app/shared/popup-edit/popup-edit.component';
import { ActivityService } from 'src/app/services/activity.service';
import { MatSort } from '@angular/material/sort';
import { FieldDesignerService } from 'src/app/services/field-designer.service';
import { DealsStageService } from 'src/app/services/deals-stage.service';
import { LeadActivityService } from 'src/app/services/lead-activity.service';
import { EditprofileComponent } from '../../lead-detail/editprofile/editprofile.component';
import { ProfileEditorDialogComponent } from '../../lead-detail/profile-editor-dialog/profile-editor-dialog.component';
import { ConfirmYesNoDialogComponent } from '../../lead-detail/confirm-yes-no-dialog/confirm-yes-no-dialog.component';
import { FieldEditDialogComponent } from '../../lead-detail/field-edit-dialog/field-edit-dialog.component';
import { DealsEntityService } from 'src/app/services/deals-entity.service';
import { DealsPipeLineService } from 'src/app/services/deals-pipe-line.service';
import { AfterSalesSubStatusService } from 'src/app/services/after-sales-sub-status.service';


export interface PipelineStep {
  stage: string;
  name: string;
  status: any;
}

export interface ActionCard {
  icon: string;
  title: string;
  links: { text: string; type: 'link' | 'button' }[];
}

export interface LeadDetails {
  lifecycleStage: string;
  pipeline: PipelineStep[];
  isKeyStakeholder: boolean;
  location: string;
  account: string;
  email: string;
  mobile: string;
  salesOwner: string;
  createdAt: string;
  actionCards: ActionCard[];
}

@Component({
  selector: 'app-deal-edit-page',
  templateUrl: './deal-edit-page.component.html',
  styleUrls: ['./deal-edit-page.component.scss'],
  animations: [
    trigger('expandCollapse', [
      state('collapsed', style({ height: '0px', overflow: 'hidden', opacity: 0 })),
      state('expanded', style({ height: '*', opacity: 1 })),
      transition('collapsed <=> expanded', animate('300ms ease-in-out'))
    ])
  ]
})

export class DealEditPageComponent implements OnInit, OnDestroy {

  basePath = environment.commonImageApi + '/profile/'
  cid: any;
  url = '';
  sanitizedUrl = '';

  tabs = [
    { name: 'Overview', icon: 'grid_view' },
    { name: 'Activities', icon: 'task_alt' },
    { name: 'Leads', icon: 'monetization_on' },
  ];


  isCollapsed = false;
  hoveredField: any = null;
  selectedField: any = null;
  editOptions = ['Edit Text', 'Change Value', 'Remove'];

  fieldTabMapping: { [key: string]: string } = {};
  useIndividualMail: any = 0;
  dealTabs: any = [];

  buildDynamicFieldMapping() {
    const defaultMapping = {
      'call duration': 'My Views',
      'status': 'Contact details',
      'lifecycle stage': 'Overview',
      'category': 'Contact details',
      'product': 'Contact details',
      'lead source': 'Contact details'
    };

    this.fieldTabMapping = { ...defaultMapping };
    const dataSources = [
      this.usedInSite,
      this.filterList,
      this.additionalSpec,
      this.DealDetailsObject?.isCustomizedValue
    ];

    dataSources.forEach(source => {
      if (source && typeof source === 'object') {
        Object.keys(source).forEach(key => {
          const lowerKey = key.toLowerCase();
          if (!this.fieldTabMapping[lowerKey]) {
            this.fieldTabMapping[lowerKey] = 'Contact details';
          }
        });
      }
    });
    const rootProperties = ['name', 'email', 'mobile', 'phoneNumber', 'secondaryphoneno', 'jobtitle', 'company', 'industry', 'website', 'country', 'city', 'state', 'zipcode', 'pincode', 'ownerIdName'];
    rootProperties.forEach(prop => {
      const lowerProp = prop.toLowerCase();
      if (!this.fieldTabMapping[lowerProp]) {
        this.fieldTabMapping[lowerProp] = 'Contact details';
      }
    });

    if (this.firstFormGroup) {
      Object.keys(this.firstFormGroup.controls).forEach(key => {
        const lowerKey = key.toLowerCase();
        if (!this.fieldTabMapping[lowerKey]) {
          this.fieldTabMapping[lowerKey] = 'Contact details';
        }
      });
    }
  }
  @Input() groupBy: any = 'activityType';
  showEditIcon = false;
  isEditMenuOpen = false;
  search: string;
  calllist: any;
  dialerType: any;
  updateType: string = null;
  pageSize: any;
  totalSize: any;
  dealActivityListFinal: Object;
  isEmpty: any;
  onScrollValue: boolean = true;
  displayOwner: boolean = false;
  leadLoaded: boolean = false;


  //for email
  emails: any[] = [];
  selectedEmail: any = null;
  currentMailBox: string = 'INBOX';
  activeTabInner: string = 'activity';
  pageIndex = 0;
  pageSizeEmail = 10;
  totalEmails = 0;
  isLoading = false;
  enableDynamicTabs: any;
  dealActivityDropDowns: Object;
  leadTabs: any;
  emailObject: any;
  emailVisble: boolean = false;
  defaultForms: any = 0;
  baseUrl: any;

  public newserverpath: string = '';
  isCollapsedtwo: boolean;
  taskCounts = {
    all: 0,
    upcoming: 0,
    overdue: 0,
    completed: 0
  };
  noOfDeals: any;
  noOfMeetings: any;
  dealSetId: any;
  defaultSet: any;
  defaultSetType: any;
  relatedCompanyId: any;
  relatedLeadId: any;
  meetingType: any = 1;
  uploadedImageUrl: string;
  totalActivity: any;
  taskType: any = 2;
  tagObject: { entityId: any; TagId: any; tagName: any; };
  tagSave: string;
  leadInvoiceType: any = 1;
  leadQuotationType: any = 1;
  notesType: any;
  lifeCycleStage: any;
  activeViewNew: 'Original' | 'basic' = 'basic';
  encryptPhone: any;
  encryptEmail: any;
  whatAppchatType: any;
  previousValue: any;
  webMobileCallEnable: any = 0;
  manageFieldCustomization: any = 0;


  toggleEditMenu(event: Event) {
    event.stopPropagation(); // Prevent unwanted clicks closing the menu
    this.isEditMenuOpen = !this.isEditMenuOpen;
  }

  saveEdit() {
    this.isEditMenuOpen = false; // Close menu after saving
  }
  generateTooltip(step: any) {
    return `Deal Stage: ${step?.statusName || ''}`;
  }

  afterSalesStageList: any[] = [];
  afterSalesSubStatusList: any[] = [];
  currentAfterSalesStatusIndex: number = -1;
  currentAfterSalesSubStatusIndex: number = -1;
  afterSalesHistoryList: any[] = [];
  showAfterSalesHistory: boolean = false;
  afterSalesAvailablePipelines: any[] = [];  // pipelines associated with current deal stage
  showPipelineSelector: boolean = false;

  loadAfterSalesPipelineData() {
    // Pipeline loading is now handled exclusively by AfterSalesPipelineTrackerComponent based on the current deal stage
  }

  loadAfterSalesHistory() {
    if (!this.DealDetailsObject?.entityId) return;
    this.dealsEntityService.getAfterSalesHistory(this.DealDetailsObject.entityId).subscribe((history: any[]) => {
      this.afterSalesHistoryList = history || [];
    });
  }

  toggleAfterSalesHistory() {
    this.showAfterSalesHistory = !this.showAfterSalesHistory;
    if (this.showAfterSalesHistory && this.afterSalesHistoryList.length === 0) {
      this.loadAfterSalesHistory();
    }
  }

  generateAfterSalesTooltip(step: any) {
    return `After-Sales Status Name : ${step.statusName}`;
  }

  updateAfterSalesStatus(event: Event, step: any) {
    event.stopPropagation();
    if (this.DealDetailsObject?.afterSalesStatus === step.statusName) {
      return;
    }
    this.DealDetailsObject.afterSalesStageId = step.statusId;
    this.DealDetailsObject.afterSalesStatus = step.statusName;
    this.snackBar.open("After-Sales status updated (API integration pending)", "Dismiss", { duration: 3000 });
  }

  updateAfterSalesSubStatus(event: Event, sub: any) {
    event.stopPropagation();
    if (!this.DealDetailsObject?.entityId) return;
    this.dealsEntityService.updateAfterSalesSubStatus(this.DealDetailsObject.entityId, sub.statusId).subscribe(
      () => {
        this.snackBar.open('After-Sales status updated successfully!', 'Dismiss', { duration: 3000 });
        this.getAllLeadDetails(this.DealDetailsObject.entityId);
      },
      (err) => {
        this.snackBar.open(err?.error || 'Failed to update After-Sales status', 'Dismiss', { duration: 4000 });
      }
    );
  }
  showToContactDetials() {
    this.setActiveTab("Contact details")
  }
  updateLeadStatus(step: any) {

    const currentStageName = this.DealDetailsObject?.statusName || this.DealDetailsObject?.dealStage || this.DealDetailsObject?.stage;
    if (currentStageName === step.statusName) {
      return;
    }

    // Update the form’s LeadStatus to the clicked step
    this.firstFormGroup.patchValue({
      LeadStatus: step.statusId
    });

    this.DealDetailsObject.statusId = step.statusId;
    this.DealDetailsObject.statusName = step.statusName;
    if (this.DealDetailsObject.dealStage) {
      this.DealDetailsObject.dealStage = step.statusName;
    }
    if (this.DealDetailsObject.stage) {
      this.DealDetailsObject.stage = step.statusName;
    }
    this.currentStatusIndex = this.filtereddropdownTypeList.findIndex(
      s => s.statusName === step.statusName
    );

    // Save to backend using your existing function
    this.saveLead();
  }
  openDeals = [
    { name: 'Widgetz.io (sample)', value: 5600, status: 'New', closes: 'Closes in Oct' }
  ];

  setActiveTab(tabName: string): void {
    this.activeTab = tabName;
    const scrollToTop = () => {
      try {
        window.scrollTo({ top: 0, behavior: 'auto' });
        const scrollContainers = document.querySelectorAll('.content, .right-content-area, .dynamic-content, mat-sidenav-content');
        scrollContainers.forEach(container => {
          const originalScrollBehavior = (container as HTMLElement).style.scrollBehavior;
          (container as HTMLElement).style.scrollBehavior = 'auto';
          container.scrollTop = 0;
          (container as HTMLElement).style.scrollBehavior = originalScrollBehavior;
        });
      } catch (e) {
        console.error('Error scrolling to top:', e);
      }
    };
    scrollToTop();
    setTimeout(scrollToTop, 0);
  }
  isPopupVisible = false;
  isEditing = false;

  // Holds the data for the note being created or edited in the popup
  currentNoteData: Partial<any> = { notes: '' };

  // Set to keep track of which notes are expanded
  private expandedNotes = new Set<number>();

  openPopup(note?: any): void {
    if (note) {
      // EDIT MODE
      this.isEditing = true;
      // Create a copy to avoid modifying the original object directly
      this.currentNoteData = { ...note };
    } else {
      // CREATE MODEfjsonRecieved
      this.isEditing = false;
      this.currentNoteData = { notes: '', documentType: 0 };
    }
    this.isPopupVisible = true;
  }

  closePopup(): void {
    this.isPopupVisible = false;
  }
  saveNote(): void {
    if (this.isEditing) {

      this.createNote(this.currentNoteData as any, this.currentNoteData.noteId!);
    } else {

      this.createNote(null, 0);
    }
    this.closePopup();
  }
  toggleShowMore(noteId: number): void {
    if (this.expandedNotes.has(noteId)) {
      this.expandedNotes.delete(noteId);
    } else {
      this.expandedNotes.add(noteId);
    }
  }

  isExpanded(noteId: number): boolean {
    return this.expandedNotes.has(noteId);
  }

  loading: boolean = false;

  toggleSection(section: any): void {
    section.isOpen = !section.isOpen;
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }

  openEditMenu(field: any, event: MouseEvent) {
    this.selectedField = field;
    event.stopPropagation();
  }

  editField(field: any, option: string) {
    console.log(`Editing ${field.label}: ${option}`);
  }


  copyEmail() {
    const email = document.querySelector(".details-email-container").firstChild.textContent.trim();
    navigator.clipboard.writeText(email).then(() => {
      alert("Copied to clipboard: " + email);
    }).catch(err => {
      console.error("Failed to copy: ", err);
    });
  }

  selectedTab = 'activities';

  // Sample data for each tab
  tabData: { [key: string]: string } = {
    activities: 'This is the Activities content.',
    notes: 'This is the Notes content.',
    calls: 'This is the Calls content.',
    files: 'This is the Files content.',
    email: 'This is the Email content.'
  };

  leadDetailPageType: any;

  selectTab(tabId: string): void {
    this.selectedTab = tabId;
  }

  dealActivityList: any = [];

  init: boolean = false;

  DealDetailsObject: any;
  leadList: any[] = [];
  leadId: any;

  public editMode = false;
  // Global inline edit flag for profile card (leadDetailPageType === 6)
  public isEditMode: boolean = false;
  leadStatusList: any;

  public selectedLeadStatus: string;
  text: string = "Save";

  leadAge: string;
  textAccount: string;
  leadPropertiesName: any;
  leadAdditionalPropertiesName: any;
  leadCommonPropertiesName: any;
  leadNoteDisplay: any;
  leadAdditionalPropertiesDisplay: any;
  leadCommonPropertiesDisplay: any;
  leadPropertiesDisplay: any;
  additionalSpec: any;
  filterList: any;

  noteList: any = [];
  replyingToNoteId: number | null = null;
  replyText: string = '';
  usedInSite: any;
  jsonRecieved: any;
  id: any;
  activityId: any;
  textCall: string;
  ownerId: any;
  type1: boolean = false;
  additionalSpecList: any = [];
  type2: boolean = false;
  valuesList: any = [];
  type3: boolean = false;
  customList: any = [];
  crmType: any;
  dialerShow: boolean = false;
  customField1: any;
  customField2: any;

  customField3: any;
  customField4: any;
  customField5: any;
  customField6: any;
  customField7: any;
  customField8: any;
  customField9: any;
  customField10: any;


  additionalData: boolean = false;
  additionalAttributeName: any;
  additionalAttributeEnable: any = 0;
  enableInvoiceInLead: any = 0;
  newType: number = 1;

  finalValueForm: any = {};
  patchValues: any;
  formInit: boolean = false;
  sameLeadName: boolean;
  emailValue: any;
  phoneValue: any;
  whatsAppCustomUrl: any;
  whatAppUrl: any;
  storeName: any;
  data: any;
  GridType: any;

  defaultForm: boolean = false;

  get isPopup(): boolean {
    return !!this.dialogRef || !!this.dialogData;
  }

  constructor(private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
    @Optional() public dialogRef: MatDialogRef<DealEditPageComponent>,
    private googleCalendarServiceAccountService: GoogleCalendarServiceAccountService,
    private dealsService: DealsService,
    private dealActivityService: DealActivityService,
    private ecryptService: EcryptServiceService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private leadService: LeadService,
    private crmNoteService: CrmNoteService,
    private productService: ProductService,
    public location: Location,
    private router: Router,
    private dynamicFormLabelService: DynamicFormLabelService,
    private changeDetector: ChangeDetectorRef,
    private loaderService: LoaderService,
    private emailSendService: EmailSendService,
    private mailBox: MailBoxService,
    private commonService: CommonService,
    private downloadImageService: DownloadImageService,
    private tagesStatusService: TagesStatusService,
    private activityService: ActivityService,
    private fieldDesignerService: FieldDesignerService,
    private usersService: UsersService,
    private dealsStageService: DealsStageService,
    private leadActivityService: LeadActivityService,
    private dealsEntityService: DealsEntityService,
    private dealsPipeLineService: DealsPipeLineService,
    private afterSalesSubStatusService: AfterSalesSubStatusService,
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }




  public serverPathEmail = environment.commonImageApi + 'gmail/';

  public serverPath = environment.commonImageApi + '/courseAudio/';

  public serverPathImage = environment.commonImageApi + 'courseImage/';

  public serverPathPdf = environment.commonImageApi + 'coursepdf/';

  public serverPathVedio = environment.commonImageApi + '/courseVideo/';

  public serverPathNotes = environment.commonImageApi + 'crmFiles/';

  modifiedname: any;

  textSend: string;

  textSubmit: String;

  userId: any;
  companyId: any;

  filterTabsForDeal() {
    if (this.isDealView) {
      if (this.tabs) {
        this.tabs = this.tabs.filter(t => t.name.toLowerCase() === 'overview' || t.name.toLowerCase() === 'activities');
      }
      if (this.leadTabs) {
        this.leadTabs = this.leadTabs.filter(t => t.name.toLowerCase() === 'activity history' || t.name.toLowerCase() === 'activity');
      }
    }
  }
  isDealView: boolean = false;

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['type'] === 'deal') {
        this.isDealView = true;
        this.filterTabsForDeal();
      }
    });
    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);
        if (data != null) {
          this.useIndividualMail = data['useIndividualMail'];
          if (this.useIndividualMail == 1) {
            this.fromEmailId.setValidators([Validators.required]);
            this.fromEmail.setValidators([Validators.required]);
          } else {
            this.fromEmailId.clearValidators();
            this.fromEmail.clearValidators();
          }
          this.fromEmailId.updateValueAndValidity();
          this.fromEmail.updateValueAndValidity();
        }
      } catch (error) {
        console.error("Failed to decrypt crmSettingsData in ngOnInit:", error);
      }
    }

    this.checkMobile();

    window.addEventListener('resize', this.checkMobile.bind(this))

    //for email

    let val = parseInt(localStorage.getItem(Constant.SU))

    if (isNaN(val)) {
      val = 0;
    }

    if (val > 0) {

      this.displayOwner = true;

    } else {
      this.displayOwner = false;
    }


    this.modifiedname = localStorage.getItem('authenticaterUserEmail') || '';
    this.selectedTab = "activities";
    this.leadId = this.route.snapshot.params['leadId'] || (this.dialogData ? this.dialogData.currentId : null);

    if (this.dialogData && (this.dialogData.allIds || this.dialogData.allEntityIds)) {
      this.allIds = this.dialogData.allIds || this.dialogData.allEntityIds || [];
      this.allEntityIds = this.allIds;
    } else if (history.state && (history.state.allIds || history.state.allEntityIds)) {
      this.allIds = history.state.allIds || history.state.allEntityIds || [];
      this.allEntityIds = this.allIds;
    }

    if (this.allIds && this.allIds.length > 0 && this.leadId) {
      const idx = this.allIds.findIndex((id: any) => String(id) === String(this.leadId));
      this.currentIndex = idx !== -1 ? idx : 0;
    } else {
      this.currentIndex = 0;
    }

    this.selectTab(this.selectedTab);
    this.getLeadDropDownList();
    this.getAllLeadDetails(this.leadId);
    this.getAllLeadActivity(this.leadId);
    this.getAllCrmData();

    console.log("dealsid", this.leadId);


    this.createFormGroup();


    this.textAccount = 'OK';


    this.textSend = "Send";

    this.textSubmit = "Submit";


    this.dialerShow = false;

    let values = localStorage.getItem(Constant.enterPriseKey);

    this.cid = "&cid=" + values

    this.getAllTags();

    this.TagsYFilter();

    this.userId = localStorage.getItem('userId');
    this.companyId = localStorage.getItem('storeName');
    this.isCollapsedtwo = true;
    this.getCount();
    this.getResource();

    this.initializeFilteredData();

    this.getSalesOwners();

  }

  toggleEditMode() {
    this.isEditMode = !this.isEditMode;
  }

  saveAllProfileEdits() {
    // Patch form controls from the inline-edited DealDetailsObject then save
    if (!this.firstFormGroup) { this.createFormGroup(); }

    try {
      this.firstFormGroup.patchValue({
        Name: this.DealDetailsObject?.name,
        Email: this.DealDetailsObject?.email,
        PhoneNumber: this.DealDetailsObject?.phoneNumber,
        Address: this.DealDetailsObject?.address || this.firstFormGroup.value.Address,
        CrName: this.DealDetailsObject?.CrName || this.firstFormGroup.value.CrName,
        CrNo: this.DealDetailsObject?.CrNo || this.firstFormGroup.value.CrNo,
        LeadStatus: this.DealDetailsObject?.statusId || this.firstFormGroup.value.LeadStatus,
        Owner: this.DealDetailsObject?.ownerId || this.firstFormGroup.value.Owner,
      });
    } catch (e) {

    }
    this.saveLead();
  }

  salesOwners: any[] = [];

  getSalesOwners() {
    try {
      this.usersService.getAllUserStatusDropDownSales().subscribe(
        (res: any) => {
          this.salesOwners = res || [];
        },
        () => { }
      );
    } catch (e) { }
  }

  onOwnerChange(selectedOwnerId: any) {
    if (selectedOwnerId === undefined || selectedOwnerId === null || selectedOwnerId === '') { return; }
    const owner = this.salesOwners.find((o: any) => String(o.entityId) == String(selectedOwnerId) || String(o.ownerId) == String(selectedOwnerId) || String(o.OwnerId) == String(selectedOwnerId));
    if (owner) {
      this.DealDetailsObject.ownerId = String(owner.entityId || owner.ownerId || owner.OwnerId);
      this.DealDetailsObject.ownerIdName = owner.email || owner.ownerEmail || owner.OwnerName || owner.name;
      if (!this.firstFormGroup) { this.createFormGroup(); }
      this.firstFormGroup.patchValue({ Owner: this.DealDetailsObject.ownerId });
    }
  }

  onStatusChange(selectedStatusId: any) {
    if (selectedStatusId === undefined || selectedStatusId === null || selectedStatusId === '') { return; }
    const status = (this.filtereddropdownTypeList || []).find((s: any) => String(s.statusId) == String(selectedStatusId) || String(s.id) == String(selectedStatusId));
    if (status) {
      this.DealDetailsObject.statusId = String(status.statusId || status.id);
      this.DealDetailsObject.statusName = status.statusName;
      if (!this.firstFormGroup) { this.createFormGroup(); }
      this.firstFormGroup.patchValue({ LeadStatus: this.DealDetailsObject.statusId });
    }
  }


  crmConfig: any;

  activityHistoryType: any = 0;



  getResource() {
    this.commonService
      .getAllAccessForResource(ResourceAccess.DEALS)
      .subscribe((data: any) => {

        if (!data.read) {
          this.router.navigate(['/unauthorized']);
        } else {

          this.resourcePrivilege = data;

        }
      });
  }


  getAllCrmData() {

    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);

        if (data != null) {

          this.activityHistoryType = data['activityHistoryType'];


        } else {

          this.activityHistoryType = 0;

        }

      } catch (error) {

      }
    }
  }


  checkMobile() {
    this.isMobileView = window.innerWidth <= 768;
  }

  backToList() {
    this.emailVisble = false;
  }


  searchText: string = '';

  icons = [
    { icon: 'note', label: 'Create a Note', name: 'Notes' },
    { icon: 'email', label: 'Create an Email', name: 'Email' },
    { icon: 'call', label: 'Make a Phone call', name: 'Call' },
    { icon: 'task', label: 'Create a task', name: 'Task' },
    { icon: 'event', label: 'Shedule a Meeting', name: 'Event' },
    { icon: 'more_vert', label: 'More', name: 'More' }
  ];

  menuItems = ['Option 1', 'Option 2', 'Option 3', 'Option 4'];
  filteredMenuItems() {
    return this.menuItems.filter(item =>
      item.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }

  onMenuItemClick(item: string) {
    console.log('Clicked:', item);
  }

  showDetails = true;
  toggleDetails() {
    this.showDetails = !this.showDetails;
  }
  openCallDialog() { }

  closeDialog() {
    this.dialog.closeAll();
  }


  templateDisplayed: any;

  enableLocation: any;

  enableCallNotes: any;

  enableSequence: boolean = false

  firstFormGroup: FormGroup;


  createFormGroup() {
    this.firstFormGroup = this.fb.group({
      CallDuration: [''],
      Country: [''],
      CreatedBy: [''],
      Description: [''],
      DoNotCall: [''],
      DoNotEmail: [''],
      Email: [''],
      LeadSource: [''],
      LeadStatus: [''],
      Name: [''],
      Notes: [''],
      Owner: [''],
      PhoneNumber: [''],
      ReceiverMobile: [''],
      Address: [''],
      CrNo: [''],
      CrName: [''],
      linkedIn: [''],
      facebook: [''],
      twitter: [''],
    });
  }


  editformGroup(leadset: any) {
    this.emailValue = leadset.email;
    this.phoneValue = leadset.phoneNumber;
    this.firstFormGroup = this.fb.group({
      CallDuration: leadset.callDuration,
      Country: leadset.Country,
      CreatedBy: leadset.createdBy,
      Description: leadset.description,
      DoNotCall: leadset.doNotCall,
      DoNotEmail: leadset.doNotEmail,
      Email: leadset.email,
      LeadSource: leadset.sourceId,
      LeadStatus: leadset.statusId,
      Name: leadset.name,
      Notes: leadset.notes,
      Owner: leadset.Owner,
      PhoneNumber: leadset.phoneNumber,
      ReceiverMobile: leadset.ReceiverMobile,
      statusName: leadset.statusName,
      sourceName: leadset.sourceName,
      statusReason: leadset.statusReason,
      Address: leadset.address,
      CrNo: leadset.CrNo,
      CrName: leadset.CrName,
      linkedIn: '',
      facebook: '',
      twitter: '',

    })

    let finalObject = {
      ...this.customField1,
      ...this.customField2,
      ...this.customField3,
      ...this.customField4,
      ...this.customField5,
      ...this.customField6,
      ...this.customField7,
      ...this.customField8,
      ...this.customField9,
      ...this.customField10,
      ...this.firstFormGroup.value
    };

    this.patchValues = finalObject;
    if (leadset.secondaryLeadStatus !== undefined) {
      this.patchValues.secondaryLeadStatus = leadset.secondaryLeadStatus;
    }


    if (this.defaultForms != null && this.defaultForms != 0 && this.defaultForms !== '') {

      this.getDefaultForm(this.defaultForms);

    } else {

      this.defaultForm = false;

    }
    this.firstFormGroup.get("twitter").setValue(this.DealDetailsObject.twitter || '');

    this.firstFormGroup.get("facebook").setValue(this.DealDetailsObject.facebook || '');

    this.firstFormGroup.get("linkedIn").setValue(this.DealDetailsObject.linkedIn || '');
    this.getLeadStatus();


  }


  mapLink: any;

  getCount() {
    this.dealsService.getDeals(0, 1, this.sortParam, this.type, this.leadId).subscribe(
      res => {

        this.noOfDeals = res['numberOfElements'];

      },
      () => {
        this.spinner = false;
      }
    )

    let sortParam = 'googleCalenderId' + "," + Constant.Dsc;
    this.googleCalendarServiceAccountService.getAllGoogleCalendar(0, 1, sortParam, 1, 2, this.leadId, this.meetingType).subscribe(
      res => {
        this.spinner = false;
        this.noOfMeetings = res['numberOfElements'];
      },
      () => {
      }
    )
  }

  getAllLeadDetails(leadId, callback?: () => void) {
    this.dealsService.getAllDealsDetailsByEntityId(leadId).subscribe(
      data => {


        if (data['entityId'] != null) {
          this.typeYFilter();
          this.DealDetailsObject = data;
          if (this.filtereddropdownTypeList && Array.isArray(this.filtereddropdownTypeList)) {
            const currentStage = this.DealDetailsObject.statusName || this.DealDetailsObject.dealStage || this.DealDetailsObject.stage;
            this.currentStatusIndex = this.filtereddropdownTypeList.findIndex(
              (s: any) => s.statusName === currentStage
            );
          } else {
            this.getLeadDropDownList();
          }
          this.leadService.getLinkedLeadByDealId(leadId).subscribe(
            (leads: any) => {
              this.leadList = leads || [];
            },
            err => {
              console.error('Error fetching linked leads: ', err);
            }
          );

          try {
            if (this.DealDetailsObject.ownerId !== undefined && this.DealDetailsObject.ownerId !== null) {
              this.DealDetailsObject.ownerId = String(this.DealDetailsObject.ownerId);
            }
            if (this.DealDetailsObject.statusId !== undefined && this.DealDetailsObject.statusId !== null) {
              this.DealDetailsObject.statusId = String(this.DealDetailsObject.statusId);
            }
          } catch (e) { }

          this.uploadedImageUrl = this.basePath + this.DealDetailsObject.image + this.cid;

          this.relatedCompanyId = this.DealDetailsObject.companyId || 0;

          this.relatedLeadId = this.DealDetailsObject.leadId || 0;

          this.customField1 = this.DealDetailsObject.customField1 || {};

          this.customField2 = this.DealDetailsObject.customField2 || {};

          this.customField3 = this.DealDetailsObject.customField3 || {};

          this.customField4 = this.DealDetailsObject.customField4 || {};

          this.customField5 = this.DealDetailsObject.customField5 || {};

          this.customField6 = this.DealDetailsObject.customField6 || {};

          this.customField7 = this.DealDetailsObject.customField7 || {};

          this.customField8 = this.DealDetailsObject.customField8 || {};


          this.customField9 = this.DealDetailsObject.customField9 || {};

          this.customField10 = this.DealDetailsObject.customField10 || {};


          this.companyId = this.DealDetailsObject.companyId || 0;

          if (this.DealDetailsObject?.isCustomizedValue?.Google_Map) {

            this.mapLink = this.DealDetailsObject?.isCustomizedValue?.Google_Map || '';

          } else {

            this.mapLink = this.DealDetailsObject?.isCustomizedValue?.GoogleMap || '';

          }

          if (this.DealDetailsObject.ast != null) {
            const keyValuePairs: [string, any][] = Object.entries(JSON.parse(this.DealDetailsObject.ast));

            this.type1 = true;
            this.additionalSpecList = keyValuePairs;
            this.additionalSpec = JSON.parse(this.DealDetailsObject.ast);
          } else {

            this.additionalSpec = this.DealDetailsObject.additionalSpec;

          }


          if (this.DealDetailsObject.valuesString != null) {
            const keyValuePairs: [string, any][] = Object.entries(JSON.parse(this.DealDetailsObject.valuesString));
            this.type2 = true;
            this.valuesList = keyValuePairs;
            this.filterList = JSON.parse(this.DealDetailsObject.valuesString);
          } else {
            this.filterList = this.DealDetailsObject.values;
          }

          if (this.DealDetailsObject.isCustomizedValueString != null) {
            const keyValuePairs: [string, any][] = Object.entries(JSON.parse(this.DealDetailsObject.isCustomizedValueString));
            this.type3 = true;
            this.customList = keyValuePairs;
            this.usedInSite = JSON.parse(this.DealDetailsObject.isCustomizedValueString);
          } else {
            this.usedInSite = this.DealDetailsObject.isCustomizedValue;
          }

          this.jsonRecieved = this.DealDetailsObject.jsonRecieved;

          this.ownerId = data['ownerId'];


          this.editformGroup(this.DealDetailsObject);

          this.leadLoaded = true;
          this.mapFieldsWithValues();
          this.buildDynamicFieldMapping();
          if (callback) callback();



        } else {


          this.snackBar.open('No Data Found!', 'X', {
            duration: 3000,
            verticalPosition: 'bottom',
            panelClass: ['error'],
          });
          this.router.navigate(['lead']);

        }


      },
      () => {
        if (callback) callback();
      })
  }
  starsArray = Array(5).fill(0);
  filledStars = 0;


  editFormTwo(event: Event) {
    event.stopPropagation();

    this.formInit = false;
    let index = this.leadStatusList.findIndex(x => x.statusId === this.firstFormGroup.value.LeadStatus);
    if (index > -1) {
      this.patchValues.LeadStatus = this.firstFormGroup.value.LeadStatus
      this.getFormArray(this.leadStatusList[index].dynamicFormGroupId);
    }
    this.editMode = !this.editMode;


  }


  editForm() {

    this.formInit = false;
    let index = this.leadStatusList.findIndex(x => x.statusId === this.firstFormGroup.value.LeadStatus);
    if (index > -1) {
      this.patchValues.LeadStatus = this.firstFormGroup.value.LeadStatus
      this.getFormArray(this.leadStatusList[index].dynamicFormGroupId);
    }
    this.editMode = !this.editMode;


  }


  // save() {

  // }

  close() {
    this.editMode = false;
  }

  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  sortParam: any = 'statusId' + "," + Constant.Dsc;

  type: any = 0;
  currentStatusIndex: number = -1;
  getLeadStatus() {
    this.dealsStageService.DealsStages(this.page, this.size, this.sortParam, this.type).subscribe(
      res => {
        this.leadStatusList = res['content'];



      },
      error => {
        console.log("Error fetching Lead Status", error);
      }
    );
  }

  checkLeadExist() {

    if ((this.emailValue != this.firstFormGroup.value.Email
      || this.phoneValue != this.firstFormGroup.value.PhoneNumber)) {
      let payload = {
        "Email": this.firstFormGroup.value.Email,
        "PhoneNumber": this.firstFormGroup.value.PhoneNumber,
        "entityId": this.leadId
      }
      this.leadService.leadAlreadyExist(payload).subscribe(
        (response) => {

          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.sameLeadName = true;
            this.saveLead();
          }
          else {
            this.text = "Save"
            this.snackBar.open(response['data']['message'], '×',
              { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        () => {
          this.text = "Save"
          this.sameLeadName = true
        });

      return this.sameLeadName;
    } else {

      this.saveLead()
    }
  }



  saveLead() {
    // this.text = "Processing"

    this.loaderService.show();
    let object = {
      "LeadStatus": this.firstFormGroup.value.LeadStatus,
      "entityId": this.leadId,
      "Name": this.firstFormGroup.value.Name,
      "Email": this.firstFormGroup.value.Email,
      "PhoneNumber": this.firstFormGroup.value.PhoneNumber,
      "Address": this.firstFormGroup.value.Address,
      "CrNo": this.firstFormGroup.value.CrNo,
      "CrName": this.firstFormGroup.value.CrName,
    }

    delete this.finalValueForm['LeadStatus'];
    let finalObject = { ...object, ...this.finalValueForm };

    const firstValue = Object.values(this.finalValueForm)[0];

    if (firstValue != undefined) {

      finalObject['secondaryLeadStatus'] = firstValue;
    }

    object = finalObject

    this.dealsService.editLead(object, this.leadId).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'] || 'Successfully Updated', '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
          this.text = "Save";
          this.editMode = false;
          this.isEditMode = false;
          this.getAllLeadDetails(this.leadId);
          this.getAllLeadActivity(this.leadId);


        } else {
          this.text = "Save";
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
        }
        this.loaderService.hide();
      },
      () => {
        this.text = "Save";
        this.loaderService.hide();
      });
  }
  callicon(icon) {
    if (icon.icon == 'note') {
      this.createNote(null, 0);
    }
    else if (icon.icon == 'call') {
      this.makeCallConnections(this.DealDetailsObject);
    }
    else if (icon.icon == 'event') {
      this.router.navigate(['/googleCalender']);
    }
  }
  createNote(note: any, noteId: any) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(CrmNoteComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "leadId": this.leadId,
          "note": note,
          "noteId": noteId,
          "type": 1,
          "designType": 1,
          "crmType": this.notesType,
          "title": " Add Notes to your lead!",
          "ownerId": this.ownerId
        }

      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getLeadNote(this.leadId);
          this.getAlldealActivityUpcoming();

          this.getAlldealActivityDue();

          this.getAlldealActivityCompleted();
        }
      });

    }
    else {
      let dialogRef = this.dialog.open(CrmNoteComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "leadId": this.leadId,
          "note": note,
          "noteId": noteId,
          "type": 1,
          "designType": 1,
          "crmType": this.notesType,
          "title": " Add Notes to your lead!",
          "ownerId": this.ownerId
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getLeadNote(this.leadId);
          this.getAlldealActivityUpcoming();

          this.getAlldealActivityDue();

          this.getAlldealActivityCompleted();
        }

      });
    }
  }

  createDocument(note: any, noteId: any) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(CrmNoteComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "leadId": this.leadId,
          "note": note,
          "noteId": noteId,
          "type": 1,
          "designType": 2,
          "title": "Attach Document",
          "ownerId": this.ownerId
        }

      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getLeadNote(this.leadId);
        }
      });

    }
    else {
      let dialogRef = this.dialog.open(CrmNoteComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "leadId": this.leadId,
          "note": note,
          "noteId": noteId,
          "type": 1,
          "designType": 2,
          "title": "Attach Document",
          "ownerId": this.ownerId
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getLeadNote(this.leadId);
        }

      });
    }
  }

  createPayment(note: any, noteId: any) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(CrmNoteComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "leadId": this.leadId,
          "note": note,
          "noteId": noteId,
          "type": 1,
          "designType": 3,
          "title": "Payment",
          "ownerId": this.ownerId
        }

      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getLeadNote(this.leadId);
        }
      });

    }
    else {
      let dialogRef = this.dialog.open(CrmNoteComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "leadId": this.leadId,
          "note": note,
          "noteId": noteId,
          "type": 1,
          "designType": 3,
          "title": "Payment",
          "ownerId": this.ownerId
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getLeadNote(this.leadId);
        }

      });
    }
  }


  sortParam1: any = 'noteId' + "," + Constant.Dsc;
  sortParam2: any = 'id' + "," + Constant.Dsc;

  getLeadNote(leadId) {

    this.crmNoteService.getAllNoteByLeadId(leadId, "1").subscribe(
      res => {
        this.noteList = res;
      },
      () => {

      }
    )
  }

  toggleReply(noteId: number | null): void {
    if (this.replyingToNoteId === noteId) {
      this.replyingToNoteId = null;
      this.replyText = '';
    } else {
      this.replyingToNoteId = noteId;
      this.replyText = '';
    }
  }

  submitReply(parentNote: any): void {
    if (!this.replyText?.trim()) return;

    const reply = {
      notes: this.replyText.trim(),
      leadId: this.leadId,
      parentNoteId: parentNote.noteId,
      type: 1,
      operationType: 'New',
      noteType: 'REPLY',
      resource: parentNote.resource || ''
    };

    this.crmNoteService.saveReply(reply).subscribe(
      (res: any) => {
        if (res?.['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(res?.['status_message'] || 'Reply sent', '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
          this.replyingToNoteId = null;
          this.replyText = '';
          this.getLeadNote(this.leadId);
        } else {
          this.snackBar.open(res?.['status_message'] || 'Failed to send reply', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
        }
      },
      () => {
        this.snackBar.open('Failed to send reply', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      }
    );
  }


  @ViewChild('delete') delete: TemplateRef<any>;

  deleteLeadDialog(activityId) {

    this.activityId = activityId;
    let dialogRef = this.dialog.open(this.delete, {
      width: '350px',
      disableClose: true,

    });
    dialogRef.disableClose = true;
  }


  submit() {
    this.deleteAllLead(this.id);
    this.dialog.closeAll();
    this.init = false;
    this.getAlldealActivity(this.leadId);
  }

  resourcePrivilege: any;
  spinner: boolean;

  deleteAllLead(id: any) {
    this.spinner = true;
    this.textAccount = "Processing";
    this.dealActivityService.deleteBydealActivityId(this.activityId).subscribe(
      response => {
        this.spinner = false;
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.getAlldealActivity(this.leadId);
        } else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
        this.textAccount = "OK";
      },
      () => {
        this.textAccount = "OK";
        this.spinner = false;
      })
  }


  @ViewChild('makeConnection') makeConnection: TemplateRef<any>;

  makeCallConnections(DealDetailsObject) {
    let dialogRef = this.dialog.open(CallListComponent, {
      width: '350px',
      disableClose: true,
      data: { data: DealDetailsObject }

    });
    dialogRef.disableClose = true;

  }

  makeCall() {
    if (this.textCall == 'Call') {
      this.spinner = true;
      this.dealActivityService.makeCall(this.DealDetailsObject).subscribe(
        response => {
          this.spinner = false;
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });
            this.dialog.closeAll();
          } else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
          }
          this.dialog.closeAll();
        },
        () => {
          this.spinner = false;
        });

    }

  }


  //leadStatus

  filtereddropdownTypeList: any;

  defaultLeadStatus: FormControl = new FormControl('');

  dropdownTypeList: any;
  dropdownList: any;
  protected _onDestroy = new Subject<void>();
  public typeYFilterControl: UntypedFormControl = new UntypedFormControl();


  getLeadDropDownList() {
    this.dealsStageService.getAllDealsStagesDropDownNew(4).subscribe(
      res => {
        this.dropdownList = res;
        this.dropdownTypeList = res;
        this.filtereddropdownTypeList = this.dropdownTypeList;
        if (this.DealDetailsObject && this.filtereddropdownTypeList) {
          const currentStage = this.DealDetailsObject.statusName || this.DealDetailsObject.dealStage || this.DealDetailsObject.stage;
          if (currentStage) {
            this.currentStatusIndex = this.filtereddropdownTypeList.findIndex(
              (s: any) => s.statusName === currentStage
            );
          }
        }
      },
      () => {
      });
  }


  typeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeidYFilter();
      });
  }


  protected typeidYFilter() {
    if (!this.dropdownTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereddropdownTypeList = this.dropdownTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtereddropdownTypeList = this.dropdownTypeList.filter(status => status['statusName'].toLowerCase().indexOf(search) > -1)
  }

  getAlldropdowntype() {
    this.filtereddropdownTypeList = this.dropdownTypeList;
  }


  object = {
    "entity_type": "Lead",
    "entity_id": "1",
    "entity_name": "yesh",
    "entity_number": "893972994",
    "tenant_id": " Account Id",
    "user_email": "calsoft_agent01@doocti.com",
    "user_id": "1",
    "user_number": "362"
  }

  @ViewChild('myFrame') myFrame: ElementRef;
  callANumber() {

    const iframeWindow = this.myFrame.nativeElement.contentWindow;

    window.addEventListener('message', this.receiveMessage.bind(this));

    const postData = {
      "entity_type": "Lead",
      "entity_id": this.DealDetailsObject.entityId,
      "entity_name": this.DealDetailsObject.name,
      "entity_number": this.DealDetailsObject.phoneNumber.toString(),
      "tenant_id": "Account Id",
      "user_email": this.DealDetailsObject.ownerEmail,
      "user_id": this.DealDetailsObject.ownerId,
      "user_number": "362",
    };

    iframeWindow.postMessage({ "data": postData }, 'https://app.doocti.com/');
  }


  receiveMessage(event: MessageEvent) {

    if (event.origin !== 'https://app.doocti.com/') {
      return;
    }

    console.log('Received message from iframe:', event.data);
  }

  opendialCall() {
    document.getElementById("mydailer").style.display = "block";
    this.dialerShow = true;
  }

  dialClose() {
    document.getElementById("mydailer").style.display = "none";
    this.dialerShow = false;
  }

  isMinimized = false;

  minimizeToggle() {
    this.isMinimized = !this.isMinimized;
  }


  download(value) {
    let smallImage = "/coursepdf/" + value;
    this.productService.downloadPdf(smallImage).subscribe(
      data => {
        downloads(data);
      },
    )
  }

  downloadNew(value) {

    this.downloadImage(value)

  }

  downloadImage(path) {

    this.downloadImageService.downloadImageNew(path);

  }

  deleteNote(value) {
    this.spinner = true;
    this.textAccount = "Processing";
    this.crmNoteService.deleteByNoteId(value.noteId).subscribe(
      response => {
        this.spinner = false;
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.getAllLeadDetails(this.leadId);
          this.getAllLeadActivity(this.leadId);
          this.getLeadNote(this.leadId)

        } else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
        this.textAccount = "OK";
      },
      () => {
        this.textAccount = "OK";
        this.spinner = false;
      })


  }

  back() {
    if (this.isPopup && this.dialogRef) {
      this.dialogRef.close();
    } else if (this.isPopup && this.dialog && this.dialog.openDialogs && this.dialog.openDialogs.length > 0) {
      this.dialog.closeAll();
    } else {
      if (window.history.length > 1) {
        this.location.back();
      } else {
        this.router.navigate(['/deals']);
      }
    }
  }

  navigateToInvoice(DealDetailsObject) {
    const encryptedDealDetailsObject = this.ecryptService.encryptionAES(JSON.stringify(DealDetailsObject));
    localStorage.setItem('leadDetailObjectData', encryptedDealDetailsObject);

    this.leadId = DealDetailsObject.entityId

    if (this.leadInvoiceType >= 12) {

      this.router.navigate([`/invoice-generation-new/${this.leadId}`])

    } else {

      this.router.navigate([`/invoice-generation/${this.leadId}`])

    }

  }
  navigateToQuotation(DealDetailsObject) {
    const encryptedDealDetailsObject = this.ecryptService.encryptionAES(JSON.stringify(DealDetailsObject));
    localStorage.setItem('leadDetailObjectData', encryptedDealDetailsObject);

    this.leadId = DealDetailsObject.entityId

    if (this.leadQuotationType >= 12) {

      this.router.navigate([`/invoice-generation-new/quotation-generate/${this.leadId}`])

    } else {

      this.router.navigate([`/invoice-generation/quotation-generate/${this.leadId}`])

    }

  }


  onFormSubmitted(event) {



    this.finalValueForm = event;


  }

  createDynamicForm(event, formGroupId, statusId) {

    if (event.isUserInput != false) {

      this.patchValues.LeadStatus = statusId

      this.formInit = false;

      this.getFormArray(formGroupId)
    }

  }


  regConfig: any[] = [];

  getFormArray(formGroupId) {

    this.dynamicFormLabelService.getDynmaicForm(formGroupId).subscribe((data) => {


      let value: any = data

      if (value.length > 0) {
        this.regConfig = value;

        this.newType = 2;
        this.formInit = true;

        this.defaultForm = true;

        this.changeDetector.detectChanges();
      } else {
        this.defaultForm = false;
        console.log("No form fields found for this Form Group ID");
      }


    });
  }
  toggleFavorite(leadData: any): void {

    leadData.favourite = leadData.favourite == 1 ? 0 : 1;


    let updatedLeadEntity = {

      entityId: leadData.entityId,
      favourite: leadData.favourite

    }

    this.loaderService.show();

    this.dealsService.editLead(updatedLeadEntity, leadData.entityId).subscribe(
      response => {

        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.text = "Save";
          this.editMode = false;
          this.updateType = 'WalkIn';
          this.getAllLeadDetails(this.leadId);
          this.getAllLeadActivity(this.leadId);


        } else {
          this.text = "Save";
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }


        this.loaderService.hide();

      },
      () => {
        this.loaderService.hide();

      }
    );
  }

  walkIn(leadData: any): void {

    leadData.walkIn = leadData.walkIn == 1 ? 0 : 1;
    let updatedLeadEntity = {

      entityId: leadData.entityId,
      walkIn: leadData.walkIn

    }
    this.loaderService.show();
    this.dealsService.editLead(updatedLeadEntity, leadData.entityId).subscribe(
      response => {

        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.text = "Save";
          this.editMode = false;
          this.updateType = 'WalkIn';
          this.getAllLeadDetails(this.leadId);
          this.getAllLeadActivity(this.leadId);


        } else {
          this.text = "Save";
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
        this.loaderService.hide();

      },
      () => {
        this.loaderService.hide();

      }
    );
  }

  phonewhatsapp(data) {

    if (this.whatsAppCustomUrl == 0) {

      let message = `Hi ${data.name}, I'm from ${this.storeName}.`;

      let phoneNumber = data.phoneNumber.replace(/\D/g, "");

      let url = `https://wa.me/${encodeURIComponent(phoneNumber)}?text=${encodeURIComponent(message)}`;

      window.open(url, '_blank');

    } else if (this.whatsAppCustomUrl == 2) {
      let contactUid = data?.whatsappContactUid || data?.contactUid || data?.uid;
      let rawPhone = data?.phoneNumber || data?.mobile || data?.phone || '';
      let phoneNumber = rawPhone ? rawPhone.toString().replace(/\D/g, "") : '';
      let target = contactUid || phoneNumber;

      if (target) {
        this.dialog.closeAll();
        this.router.navigate(['/whatsAppChat'], { queryParams: { contact: target } });
      } else {
        alert("Contact information not available");
      }
    } else {

      let url = this.whatAppUrl;
      if (url != null) {
        window.open(url, '_blank');
      } else {
        alert("Please Update CrmSetting")
      }

    }
  }

  phoneSms(data) {

    let phoneNumber = data.phoneNumber.replace(/\D/g, "");

    // window.location.href = "sms:" + phoneNumber;

    let message = `Hi ${data.name}, I'm from ${this.storeName}.`;

    window.location.href = `sms:${phoneNumber}?&body=${encodeURIComponent(message)}`;

  }

  navigatelink(value) {

    window.open(value, '_blank');

  }

  openEditDialog(): void {
    const dialogRef = this.dialog.open(EditprofileComponent, {
      width: '400px',
      data: {
        firstName: this.DealDetailsObject.firstName,
        lastName: this.DealDetailsObject.lastName,
        jobTitle: this.DealDetailsObject.jobTitle
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.DealDetailsObject.firstName = result.firstName;
        this.DealDetailsObject.lastName = result.lastName;
        this.DealDetailsObject.name = `${result.firstName} ${result.lastName}`;
        this.DealDetailsObject.jobTitle = result.jobTitle;
      }
    });
  }

  getcallList() {

    let sortParam: any = 'id' + "," + Constant.Dsc;

    this.search = `activityType:*OutboundCall,* AND leadId:${this.leadId}`;

    this.spinner = true;
    this.dealActivityService.searchAllActivity(this.search, this.page, this.size, sortParam, this.groupBy).subscribe(
      res => {
        this.spinner = false;
        this.calllist = res['content'];

      },
      () => {
        this.spinner = false;
      })
  }



  emailtemplateId = new FormControl('', [Validators.required]);
  fromEmailId = new FormControl('', [Validators.required]);
  fromEmail = new FormControl('', [Validators.required]);
  filteredEmaildropdownTypeList: any;
  dropdownEmailTypeList: any;
  dropdownEmailList: any;
  typeEmailYFilterControl: UntypedFormControl = new UntypedFormControl();




  openViewDialog(): void {
    let image = this.DealDetailsObject?.image;
    this.dialog.open(ProfileEditorDialogComponent, {
      width: '400px', // Set the width of the side panel
      height: '100vh', // Full height
      position: {
        top: '0',
        right: '0' // Position on the right
      },
      panelClass: 'profile-editor-panel', // Apply our custom class for animation
      data: { imageUrl: image }
    }).afterClosed().subscribe(result => {
      if (result) {
        let filename = "";
        let imageUrl = "";
        if (result.action === 'remove') {
          // this.imageChanged.emit('remove');
        } else if (result.action === 'upload') {
          filename = result.fileName;
          imageUrl = result.mediaUrl;

        } else {
          return;
        }


        let object = {
          "entityId": this.leadId,
          "Image": filename
        }

        this.dealsService.editLead(object, this.leadId).subscribe(
          (response) => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open('You added a display picture', '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
              this.text = "Save";
              this.editMode = false;
              this.getAllLeadDetails(this.leadId);
              this.getAllLeadActivity(this.leadId);


            } else {
              this.text = "Save";
              this.snackBar.open('Something went wrong on our side. Please try again in a minute.', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
            }
            this.loaderService.hide();
          },
          () => {
            this.text = "Save";
            this.loaderService.hide();
          });
      }
    });
  }


  opendialCallsa(data) {
    document.getElementById("mydailer").style.display = "block";
    this.dialerShow = true;
    this.data = data
  }



  callANumber1(number, phone) {

    const iframeWindow = this.myFrame.nativeElement.contentWindow;

    window.addEventListener('message', this.receiveMessage.bind(this));


    const postData = {
      "entity_type": "Lead",
      "entity_id": number.entityId,
      "entity_name": number.name,
      "entity_number": phone.toString(),
      "tenant_id": "Account Id",
      "user_email": number.ownerEmail,
      "user_id": number.ownerId,
      "user_number": "362"
    };

    iframeWindow.postMessage({ "data": postData }, 'https://app.doocti.com/');
  }

  editEmailSend(id) {
    this.router.navigate([`/emailSend/editEmailSend/${id}`])
  }

  emailList: any;

  getAllEmailSend(leadId) {
    this.emailSendService.getAllEmailByLeadId(leadId).subscribe(
      res => {
        this.emailList = res;

      },
      () => {

      }
    )
  }

  groupedActivities: { [key: string]: any[] } = {};
  selectTabInner(tabName: string): void {
    if (!tabName) tabName = 'activity';
    this.activeTabInner = tabName;
    if (tabName === 'Email Sent' || tabName === 'Email' || tabName === 'Email Status') {
      if (!this.currentMailBox) {
        this.currentMailBox = 'INBOX';
      }
      this.loadEmails({ value: this.currentMailBox });
    }
  }
  private relativeTimeCache = new Map<string, { time: number; result: string }>();

  getRelativeTime(dateString: string): string {
    if (!dateString) return '';
    const now = Date.now();
    const cached = this.relativeTimeCache.get(dateString);
    if (cached && (now - cached.time < 5000)) {
      return cached.result;
    }

    const activityDate = new Date(dateString);
    if (isNaN(activityDate.getTime())) return '';

    const diffInSeconds = Math.floor((now - activityDate.getTime()) / 1000);

    const intervals: { [key: string]: number } = {
      'year': 31536000,
      'month': 2592000,
      'day': 86400,
      'hour': 3600,
      'minute': 60
    };

    let result = 'Just now';
    for (const intervalName in intervals) {
      const interval = intervals[intervalName];
      const count = Math.floor(diffInSeconds / interval);
      if (count > 0) {
        result = `${count} ${intervalName}${count > 1 ? 's' : ''} ago`;
        break;
      }
    }

    this.relativeTimeCache.set(dateString, { time: now, result });
    return result;
  }
  getIconForActivity(type: string, activity?: any): string {
    const rawType = (type || activity?.activityType || activity?.type || '').toString().trim();
    const t = rawType.toLowerCase();

    if (
      t.includes('phone') ||
      t.includes('call') ||
      t.includes('mobile') ||
      t === 'incoming' ||
      t === 'outgoing' ||
      t === 'connected'
    ) {
      return 'phone';
    }

    if (
      t.includes('stage') ||
      t.includes('dealstatus') ||
      t === 'statuschange'
    ) {
      return 'track_changes';
    }

    switch (t) {
      case 'task': return 'check_box_outline_blank';
      case 'meeting': return 'groups';
      case 'email': return 'mail_outline';
      case 'stagechange': return 'track_changes';
      case 'ownerchange': return 'person_outline';
    }

    if (t.includes('email')) return 'mail_outline';
    if (t.includes('payment')) return 'payments';
    if (t.includes('meeting')) return 'groups';
    if (t.includes('owner')) return 'person_outline';
    if (t.includes('task') || t === 'follow up') return 'check_box_outline_blank';

    const act = activity || {};
    const content = `${act.subject || ''} ${act.notes || ''} ${act.title || ''} ${act.description || ''} ${act.fieldName || ''}`.toLowerCase();
    if (content.includes('deal stage') || content.includes('stage')) {
      return 'track_changes';
    }
    if (content.includes('phone number') || content.includes('phone') || content.includes('mobile')) {
      return 'phone';
    }

    return 'history_toggle_off'; // A generic fallback icon
  }
  getAlldealActivity(leadId) {


    // this.loaderService.show();

    this.onScrollValue = true;

    this.dealActivityService.getAllDealActivityByPageable(0, 10, 'id,desc', leadId, String(this.taskType || 2)).subscribe(
      data => {

        // this.onScrollValue = false;

        this.totalSize = data["totalPages"];

        this.dealActivityList = data['content'];


        this.total = data['numberOfElements'];

        this.dealActivityListFinal = data;

        this.processActivities();
        this.processTasks();

        this.totalActivity = data['totalElements']


        this.init = true;

        this.pagetwo = 0;

        this.loaderService.hide();

      },
      () => {
        this.onScrollValue = false;


      })
  }
  private processActivities(): void {

    const sortedActivities = this.dealActivityList.sort((a, b) =>
      new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
    );

    const groups: { [key: string]: any[] } = {};
    const datePipe = new DatePipe('en-US');

    for (const activity of sortedActivities) {
      const dateKey = datePipe.transform(activity.createdDate, 'MMMM d, yyyy')!;
      if (!groups[dateKey]) {
        groups[dateKey] = [];
      }
      groups[dateKey].push(activity);
    }
    this.groupedActivities = groups;
  }
  private processTasks(): void {
    this.taskCounts.all = this.dealActivityList.length;
    this.taskCounts.completed = this.dealActivityList.filter(t => t.isCompleted).length;
    this.taskCounts.overdue = this.dealActivityList.filter(t => !t.isCompleted && new Date(t.dueDate) < new Date()).length;
    this.taskCounts.upcoming = this.dealActivityList.filter(t => !t.isCompleted && new Date(t.dueDate) >= new Date()).length;

    this.setTaskFilter('all');
  }
  filteredTasks: any[] = [];
  activeTaskFilter: string = 'all';
  setTaskFilter(filter: string): void {
    this.activeTaskFilter = filter;

  }



  pagetwo = 0;
  isMobileView: boolean = false;
  selectedIndex: number | null = null;
  onScroll() {
    if (this.pagetwo < this.totalSize - 1) {
      this.spinner = true;
      this.onScrollValue = true;
      this.pagetwo++;

      this.dealActivityService.getAllDealActivityByPageable(this.pagetwo, 10, 'id,desc', this.leadId, String(this.taskType || 2)).subscribe(
        res => {
          if (res['content']?.length) {
            this.dealActivityList = [...this.dealActivityList, ...res['content']];
          }

          this.totalSize = res["totalPages"];
          this.isEmpty = res["empty"];
          this.onScrollValue = this.pagetwo < this.totalSize - 1;
          this.spinner = false;
        },
        error => {
          console.error("Error loading activity:", error);
          this.spinner = false;
          this.onScrollValue = false;
        }
      );
    } else {
      this.spinner = false;
      this.onScrollValue = false;
    }
  }


  onScrollNew() {
    if (this.pagetwo < this.totalSize - 1) {
      this.spinner = true;
      this.onScrollValue = false; // prevent multiple triggers

      this.pagetwo++;

      this.dealActivityService
        .getAllDealActivityByPageable(this.pagetwo, 10, 'id,desc', this.leadId, String(this.taskType || 2))
        .subscribe(
          res => {
            if (res['content']?.length) {
              this.dealActivityList = [...this.dealActivityList, ...res['content']];
              this.processActivities(); // regroup and update groupedActivities
            }

            this.totalSize = res["totalPages"];
            this.onScrollValue = this.pagetwo < this.totalSize - 1;
            this.spinner = false;
          },
          error => {
            console.error("Error loading more activities:", error);
            this.spinner = false;
            this.onScrollValue = false;
          }
        );
    }
  }




  //for email 
  extractEmailAddress(from: string): string {
    const match = from.match(/<(.+?)>|(\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z]{2,}\b)/i);
    return match ? (match[1] || match[2]) : from;
  }
  truncateText(text: string, limit: number = 150): string {
    return text?.length > limit ? text.substring(0, limit) + '...' : text;
  }


  loadEmails(event?: any) {

    this.isLoading = true;
    this.selectedIndex = null;
    this.emailVisble = false;

    if (!event || !event.value) {
      event = { value: this.currentMailBox || 'INBOX' };
    }

    this.currentMailBox = event.value;

    const emailToFilter = this.DealDetailsObject?.email;
    let timeoutTriggered = false;
    const loadingTimeout = setTimeout(() => {
      timeoutTriggered = true;
      this.isLoading = false;
      console.warn('Email loading timeout exceeded');
    }, 10000);

    this.mailBox
      .filterByEmail(this.pageIndex, this.pageSizeEmail, event.value, emailToFilter)
      .subscribe({
        next: (response) => {
          if (timeoutTriggered) return;
          this.emails = response['data']['emails']?.map((email: any) => this.transformEmailDto(email)) || [];
          this.totalEmails = response['data']['totalMessages'];
          if (this.emails.length > 0) {
            this.selectEmail(0);
          }
        },
        error: (error) => {
          console.error('Error fetching filtered emails:', error);
        }
      })
      .add(() => {
        if (!timeoutTriggered) {
          clearTimeout(loadingTimeout);
          this.isLoading = false;
        }
      });
  }

  selectEmail(index: number): void {
    this.selectedIndex = index;
    this.emailObject = this.emails[index];
    this.selectedEmail = this.emails[index];
    this.emailVisble = true;
  }


  transformEmailDto(email: any): any {
    const rawBody = email.body && String(email.body).trim();
    const bodyContent = rawBody ? email.body : (email.snippet || '');
    return {
      ...email,
      subject: email.subject || '(No Subject)',
      body: bodyContent,
      attachments: email.attachments || [],
      sentDate: new Date(email.sentDate)
    };
  }
  onPageChange(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSizeEmail = event.pageSize;

  }
  linkifyAndSanitize(html: string): SafeHtml {
    const cleanedHtml = this.extractBodyContent(html);
    return this.sanitizer.bypassSecurityTrustHtml(cleanedHtml);
  }

  isImage(contentType: string): boolean {
    return contentType.startsWith('image/');
  }


  extractBodyContent(html: string): string {
    const bodyMatch = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
    let bodyContent = bodyMatch ? bodyMatch[1] : html;

    bodyContent = bodyContent
      .replace(/<!DOCTYPE[^>]*>/gi, '')
      .replace(/<html[^>]*>|<\/html>/gi, '')
      .replace(/<head[^>]*>[\s\S]*?<\/head>/gi, '')
      .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
      .trim();

    return bodyContent;
  }
  //lead activity 
  truncateSafeHTML(html: string, length: number): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    const text = div.innerText || '';
    return text.length > length ? text.substring(0, length) + '…' : text;
  }

  save() {
    this.showEditPopup = false;
  }




  showEditPopup = false;


  openEditPopup1() {
    this.showEditPopup = true;
  }

  closeEditPopup() {
    this.showEditPopup = false;
  }

  @ViewChild(SimpleDynamicFormComponent, { static: false })
  simpleDynamicFormComponent:
    SimpleDynamicFormComponent;
  submitNew() {

    if (this.regConfig.length > 0) {
      this.type = 2;
      this.simpleDynamicFormComponent.onSubmitNew();

    } else {
      this.firstFormGroup.value.dynamicFieldValues = [];
      this.checkLeadExist();
    }


  }

  saveNew() {

    this.checkLeadExist();
  }

  defaultConfig: any[] = [];

  getDefaultForm(formGroupId) {

    this.dynamicFormLabelService.getDynmaicForm(formGroupId).subscribe((data) => {


      let value: any = data

      if (value.length > 0) {
        this.defaultConfig = value;

        this.newType = 2;

        this.defaultForm = true;

      } else {
        this.defaultForm = false;
        console.log("No form fields found for this Form Group ID");
      }


    });
  }


  dialerEnable: boolean = false;
  lastDialedNumber: any;

  newdialer(number) {
    this.dialerEnable = true;
    this.lastDialedNumber = number;
    if (this.dialerType == 7) {
      this.callANumberNew(number)
    }

  }

  iframeUrl: string = '';

  initDialer() {

    const userId = localStorage.getItem('userId');
    const companyId = localStorage.getItem('storeName');

    const baseUrl = 'https://client5.rekzyl.com/voice/dialpad';
    const params = new URLSearchParams({
      leftServiceId: '93eeb600-dcb1-4382-bf11-846c467deb79',
      service: 'calsoft',
      sideBar: 'false',
      topBar: 'false',
      fullView: 'false',
      userId: userId,
      companyId: companyId,
    });

    this.iframeUrl = `${baseUrl}?${params.toString()}`;
    this.changeDetector.detectChanges();
  }

  @ViewChild('myHelloSendFrame', { static: false }) myHelloSendFrame: ElementRef;

  onIframeLoaded() {
    setTimeout(() => {
      if (!this.myHelloSendFrame?.nativeElement) {
        console.error('iframe element not yet available');
        return;
      }
      this.callANumberNew(this.lastDialedNumber);
    }, 0);
  }

  callANumberNew(DealDetailsObject) {
    const iframeWindow = window.frames['myDialerFrame'] as Window;

    if (!iframeWindow) {
      console.error('Iframe window is not available');
      return;
    }


    let phone = "+" + DealDetailsObject.phoneNumber.toString();

    const postData = {
      entity_type: "Lead",
      entity_id: DealDetailsObject.entityId,
      entity_name: DealDetailsObject.name,
      entity_number: phone,
      user_email: DealDetailsObject.ownerEmail,
      user_id: DealDetailsObject.ownerId,
      event_action: "click2call"
    };


    iframeWindow.postMessage(postData, 'https://client5.rekzyl.com');

    const messageHandler = (event: MessageEvent) => {
      if (event.origin !== 'https://client5.rekzyl.com') return;
      console.log('Response received from iframe:', event.data);
      window.removeEventListener('message', messageHandler);
    };

    window.addEventListener('message', messageHandler);
  }

  closeDialer() {
    this.dialerEnable = false;
  }

  sendDialPadAction(action: 'MAXIMIZE_DIAL_PAD' | 'MINIMIZE_DIAL_PAD') {
    const iframeWindow = this.myHelloSendFrame?.nativeElement?.contentWindow;

    if (!iframeWindow) {
      console.error('Iframe is not ready to receive messages');
      return;
    }

    const postMessageData = {
      event_action: action
    };

    iframeWindow.postMessage(postMessageData, 'https://client5.rekzyl.com');
  }

  getStars(rating: number): boolean[] {
    return Array(5).fill(false).map((_, i) => i < rating);
  }

  toggleCollapsetwo() {
    this.isCollapsedtwo = !this.isCollapsedtwo;
  }

  activeTab: string = 'Overview';

  selectTabs(tabKey: string): void {
    this.activeTab = tabKey;
    const scrollToTop = () => {
      try {
        window.scrollTo({ top: 0, behavior: 'auto' });
        const scrollContainers = document.querySelectorAll('.content, .right-content-area, .dynamic-content, mat-sidenav-content');
        scrollContainers.forEach(container => {
          const originalScrollBehavior = (container as HTMLElement).style.scrollBehavior;
          (container as HTMLElement).style.scrollBehavior = 'auto';
          container.scrollTop = 0;
          (container as HTMLElement).style.scrollBehavior = originalScrollBehavior;
        });
      } catch (e) {
        console.error('Error scrolling to top:', e);
      }
    };
    scrollToTop();
    setTimeout(scrollToTop, 0);
  }



  openSocialUrl(type: 'facebook' | 'twitter' | 'linkedIn', event: MouseEvent) {
    event.stopPropagation();
    const url = this.firstFormGroup.get(type)?.value;

    if (!url) {
      this.snackBar.open(`No ${type} URL found`, '×', {
        panelClass: 'error',
        duration: 3000
      });
      return;
    }

    this.loaderService.show();
    try {
      const fullUrl = (String(url).trim().startsWith('http')) ? String(url).trim() : `https://${String(url).trim()}`;
      const win = window.open(fullUrl, '_blank');
      if (!win) {
        // popup blocked
        this.snackBar.open(`Could not open ${type} URL`, '×', { panelClass: 'error', duration: 3000 });
      }
    } catch (err) {
      this.snackBar.open(`Invalid ${type} URL`, '×', { panelClass: 'error', duration: 3000 });
    } finally {
      this.loaderService.hide();
    }
  }
  activeView: 'all' | 'basic' = 'all';

  // Manages the state of collapsible sections in the 'All details' view
  isBasicInfoOpen = true;
  isMoreFieldsOpen = true;

  // Static contact data from the images
  contact = {
    email: 'janesampleton@gmail.com',
    firstName: 'Jane',
    lastName: 'Sampleton (sample)',
    jobTitle: 'CEO',
    account: 'Widgetz.io (sample)',
    mobilePhone: '+19266529503',
    workPhone: '+13684932360',
    salesOwner: 'Pavitharan',
    tags: ['Decision maker'],
    source: 'Web',
    address: '604-5854 Beckford St.',
    city: 'Glendale',
    state: 'Arizona',
    country: 'USA',
    zipcode: '100652',
    lifecycleStage: 'Lead',
    status: 'New',
    lostReason: null,
    subscriptionStatus: 'Subscribed',
    subscriptionTypes: 'Newsletter, Promotional, Product updates, Conf...',
    unsubscribeReason: null,
    otherUnsubscribeReasons: null,
    score: 52,
    customerFit: 2, // Representing 2 out of 5 stars
    social: {
      linkedin: 'jane-sampleton-0b0039109',
      twitter: 'janesampleton',
      facebook: '100010587455650'
    }
  };

  // Function to switch between 'All details' and 'Basic information' views
  setView(view: 'all' | 'basic'): void {
    this.activeView = view;
  }

  // Functions to toggle the collapsible sections
  toggleBasicInfo(): void {
    this.isBasicInfoOpen = !this.isBasicInfoOpen;
  }

  toggleMoreFields(): void {
    this.isMoreFieldsOpen = !this.isMoreFieldsOpen;
  }

  deleteAllProductId(id: any) {
    this.spinner = true;
    this.textAccount = "Processing";
    this.dealsService.deleteByDealsId(id).subscribe(
      response => {
        this.spinner = false;
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.dialog.closeAll();
        } else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
        this.textAccount = "OK";
      },
      error => {
        this.textAccount = "OK";
        this.spinner = false;
      })

  }

  editProduct(dealId, setId) {
    this.dialog.closeAll();
    this.router.navigate([`deals/add-edit-deals/${dealId}/${setId}`])
  }




  imageError = false;

  setError() {

    this.imageError = true;
  }


  @ViewChild('tagName') tagName: TemplateRef<any>;

  tagNames: UntypedFormControl = new UntypedFormControl([], [Validators.required]);

  opentagName() {

    this.tagNames.patchValue(this.DealDetailsObject?.tagName || '');

    let dialogRef = this.dialog.open(this.tagName, {
      width: '750px',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getAllLeadDetails(this.leadId);
      this.getAllLeadActivity(this.leadId);
    });
  }

  //Tags

  tagsList: any = [];
  tagsTypeList: any = [];
  filteredtagsTypeList: any = [];
  tagsControl: UntypedFormControl = new UntypedFormControl();
  tagsFilterControl: UntypedFormControl = new UntypedFormControl();


  getAllTags() {
    this.tagesStatusService.getAllTagsDropDown(5).subscribe(
      data => {
        this.tagsList = data;
        this.tagsTypeList = data;
        this.filteredtagsTypeList = this.tagsTypeList;
      },
      () => {
      }
    )
  }

  TagsYFilter() {
    this.tagsFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.tagsFilter();
      });
  }

  protected tagsFilter() {
    if (!this.tagsTypeList) {
      return;
    }
    // get the search keyword
    let search = this.tagsFilterControl.value;
    if (!search) {
      this.filteredtagsTypeList = this.tagsTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    const currentSelected = Array.isArray(this.tagNames.value)
      ? this.tagNames.value
      : (this.tagNames.value ? [this.tagNames.value] : []);

    this.filteredtagsTypeList = this.tagsTypeList.filter(tags => {
      const matchesSearch = tags['statusName'] && tags['statusName'].toLowerCase().indexOf(search) > -1;
      const isSelected = currentSelected.some(sel =>
        sel === tags.statusName ||
        sel == tags.statusId ||
        (tags.statusName && String(sel).toLowerCase() === tags.statusName.toLowerCase())
      );
      return matchesSearch || isSelected;
    });
  }

  setTagName(event, tag) {

    if (event.isUserInput != false) {

      let object = {
        "entityId": this.leadId,
        "TagId": tag.statusId,
        "tagName": tag.statusName,
        "Tags": tag.statusId
      }

      this.tagObject = object;


    }
  }

  submitTagName() {
    if (this.textSubmit == 'Send' && this.tagNames.valid) {

      this.textSubmit = "Processing"

      let object = {
        "entityId": this.leadId,
        "tagName": this.tagNames.value
      }


      this.dealsService.editLead(object, this.leadId).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.dialog.closeAll();
            // this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          } else {
            this.dialog.closeAll();
            // this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        () => {
        });
    }
    else {
      this.firstFormGroup.markAllAsTouched();
    }
  }

  tagNameUpdate() {


    this.tagSave = "Processing";
    this.dealsService.editLead(this.tagObject, this.leadId).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

          this.tagSave = "Save";
          this.DealDetailsObject.tagName = this.tagObject.tagName
          this.snackBar.open(response['status_message'] || 'Successfully Updated', '×', {
            panelClass: 'success',
            verticalPosition: 'bottom',
            duration: 3000
          });
          this.dialog.closeAll();
        } else {
          this.tagSave = "Save";
          this.snackBar.open(response['status_message'] || 'Update failed', '×', {
            panelClass: 'error',
            verticalPosition: 'bottom',
            duration: 3000
          });
        }
      },
      () => {
        this.tagSave = "Save";
      });


  }



  lostReason() {
    let element = this.DealDetailsObject;
    let colProperty = "lostReason";
    let value = this.DealDetailsObject.lostReason
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(PopupEditComponent, {
        width: '400px',
        height: '214px',
        disableClose: true,
        data: {
          element: element,
          key: colProperty,
          previousValue: value,
          inputType: 'text'
        },

      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          let value = result['data']
          if (value != undefined || value != null) {
            this.DealDetailsObject.lostReason = value;
            let object: any = {
              entityId: this.leadId,
              lostReason: value
            };
            this.saveLeadObject(object)
          }

        }
      });

    }
    else {
      let dialogRef = this.dialog.open(PopupEditComponent, {
        minWidth: '100vw', height: '100vh',
        disableClose: true,
        data: {
          element: element,
          key: colProperty,
          previousValue: value,
          inputType: 'text'
        },

      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          let value = result['data']

          if (value != undefined || value != null) {
            this.DealDetailsObject.lostReason = value;
            let object: any = {
              entityId: this.leadId,
              lostReason: value
            };
            this.saveLeadObject(object)
          }

        }

      });
    }
  }

  saveLeadObject(object) {


    this.dealsService.editLead(object, this.leadId).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', {
            panelClass: 'success',
            verticalPosition: 'bottom',
            duration: 500
          });
        } else {
          this.snackBar.open(response['status_message'], '×', {
            panelClass: 'error',
            verticalPosition: 'bottom',
            duration: 500
          });
        }
      },
      () => {
        this.snackBar.open("Save failed", '×', {
          panelClass: 'error',
          verticalPosition: 'bottom',
          duration: 500
        });
      }
    );
  }


  //new type

  total: number;
  dealActivityListUpcoming: any = [];
  dealActivityListFinalUpcoming: any = [];
  dealActivityListCompleted: any = [];
  dealActivityListFinalCompleted: any = [];
  dealActivityListDue: any = [];
  dealActivityListDueFinal: any = [];
  totalCompleted: any = 0;
  totalOverdue: any = 0;
  totalUpcoming: any = 0;
  onScrollValueUpcoming: any = false;
  pagetwoUpComing = 0;

  onScrollValueDue: any = false;
  pagetwoDue = 0;
  totalActivityUpComing: any = 0;

  getAlldealActivityUpcoming() {


    this.onScrollValueUpcoming = true;

    let search = "a.taskType:*" + (this.taskType || 2) + ",* AND a.leadId:*" + this.leadId + ",* AND a.status:*0,*";

    this.activityService.ActivityUpcomingReport(search, 0, 10, 'id,desc', '').subscribe(
      data => {

        this.onScrollValueUpcoming = false;

        this.totalSizeUpcoming = data["totalPages"];

        this.dealActivityListUpcoming = data['content'];

        this.totalUpcoming = data['numberOfElements'];

        this.totalActivityUpComing = data['totalElements']

        this.dealActivityListFinalUpcoming = data;
        this.init = true;

        this.pagetwoUpComing = 0;

      },
      () => {
        this.onScrollValueUpcoming = false;


      })
  }
  pagetwoUpcoming: any;
  totalSizeUpcoming: any;
  onScrollUpcoming() {
    if (this.pagetwoUpcoming < this.totalSizeUpcoming - 1) {
      this.spinner = true;
      this.onScrollValueUpcoming = true;
      this.pagetwoUpcoming++;
      let search = "a.taskType:*" + (this.taskType || 2) + ",* AND a.leadId:*" + this.leadId + ",* AND a.status:*0,*";
      this.activityService.ActivityUpcomingReport(search, this.pagetwoUpcoming, 10, 'id,desc', '').subscribe(
        res => {
          if (res['content']?.length) {
            this.dealActivityListUpcoming = [...this.dealActivityListUpcoming, ...res['content']];
          }

          this.totalSizeUpcoming = res["totalPages"];
          this.isEmpty = res["empty"];
          this.onScrollValueUpcoming = this.pagetwo < this.totalSize - 1;
          this.spinner = false;
          this.totalActivityUpComing = res['totalElements']
        },
        error => {
          console.error("Error loading activity:", error);
          this.spinner = false;
          this.onScrollValueUpcoming = false;
        }
      );
    } else {
      this.spinner = false;
      this.onScrollValueUpcoming = false;
    }
  }

  totalDue: any = 0;
  totalActivityDue: any = 0;
  getAlldealActivityDue() {

    this.onScrollValueDue = true;

    let search = "a.taskType:*" + (this.taskType || 2) + ",* AND a.leadId:*" + this.leadId + ",* AND a.status:*0,*";

    this.activityService.searchDynamicLeadReport(search, 0, 10, 'id,desc', '').subscribe(
      data => {

        this.onScrollValueDue = false;

        this.totalSizeDue = data["totalPages"];

        this.dealActivityListDue = data['content'];


        this.totalDue = data['numberOfElements'];

        this.dealActivityListDueFinal = data;

        this.init = true;

        this.pagetwoDue = 0;
        this.totalActivityDue = data['totalElements']

      },
      () => {
        this.onScrollValueDue = false;


      })
  }

  totalSizeDue: any;
  onScrollUpDue() {
    if (this.pagetwoDue < this.totalSizeDue - 1) {
      this.spinner = true;
      this.onScrollValueUpcoming = true;
      this.pagetwoDue++;
      let search = "a.taskType:*" + (this.taskType || 2) + ",* AND a.leadId:*" + this.leadId + ",* AND a.status:*0,*";
      this.activityService.searchDynamicLeadReport(search, this.pagetwoDue, 10, 'id,desc', '').subscribe(
        res => {
          if (res['content']?.length) {
            this.dealActivityListDue = [...this.dealActivityListDue, ...res['content']];
          }

          this.totalSizeDue = res["totalPages"];

          this.totalActivityDue = res['totalElements']
          this.isEmpty = res["empty"];
          this.onScrollValueDue = this.pagetwo < this.totalSize - 1;
          this.spinner = false;
        },
        error => {
          console.error("Error loading activity:", error);
          this.spinner = false;
          this.onScrollValueDue = false;
        }
      );
    } else {
      this.spinner = false;
      this.onScrollValueDue = false;
    }
  }

  onScrollValueCompleted: any = false;
  pagetwoCompleted: any = 0;
  totalActivityCompleted: any = 0;
  getAlldealActivityCompleted() {



    this.onScrollValueCompleted = true;

    let search = "a.taskType:*" + (this.taskType || 2) + ",* AND a.leadId:*" + this.leadId + ",* AND a.status:*1,*";

    this.dealActivityService.searchAllActivity(search, 0, 10, 'id,desc', '').subscribe(
      data => {

        this.onScrollValueCompleted = false;

        this.totalSizeCompleted = data["totalPages"];

        this.dealActivityListCompleted = data['content'];

        this.totalCompleted = data['numberOfElements'];

        this.dealActivityListFinalCompleted = data;

        this.init = true;

        this.pagetwoCompleted = 0;

        this.totalActivityCompleted = data['totalElements']

      },
      () => {
        this.onScrollValueCompleted = false;


      })
  }

  totalSizeCompleted: any;
  onScrollUpCompleted() {
    if (this.pagetwoCompleted < this.totalSizeCompleted - 1) {
      this.spinner = true;
      this.onScrollValueUpcoming = true;
      this.pagetwoCompleted++;
      let search = "a.taskType:*" + (this.taskType || 2) + ",* AND a.leadId:*" + this.leadId + ",* AND a.status:*1,*";
      this.dealActivityService.searchAllActivity(search, this.pagetwoCompleted, 10, 'id,desc', '').subscribe(
        res => {
          if (res['content']?.length) {
            this.dealActivityListCompleted = [...this.dealActivityListCompleted,
            ...res['content']];
          }

          this.totalSizeCompleted = res["totalPages"];
          this.isEmpty = res["empty"];
          this.onScrollValueCompleted = this.pagetwoCompleted < this.totalSizeCompleted - 1;
          this.spinner = false;
          this.totalActivityCompleted = res['totalElements']
        },
        error => {
          console.error("Error loading activity:", error);
          this.spinner = false;
          this.onScrollValueCompleted = false;
        }
      );
    } else {
      this.spinner = false;
      this.onScrollValueCompleted = false;
    }
  }


  updateLeadStatusFromPopup(opt: any) {
    if (!opt || !opt.statusId) return;

    let object = {
      "entityId": this.leadId,
      "Stage": opt.statusId
    }

    this.dealsService.editLead(object, this.leadId).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.DealDetailsObject.statusId = opt.statusId;
          this.DealDetailsObject.statusName = opt.statusName;
          if (this.DealDetailsObject.dealStage) {
            this.DealDetailsObject.dealStage = opt.statusName;
          }
          if (this.DealDetailsObject.stage) {
            this.DealDetailsObject.stage = opt.statusName;
          }
          this.currentStatusIndex = this.filtereddropdownTypeList.findIndex(
            s => s.statusName === opt.statusName
          );
          this.snackBar.open("Deal Stage Auto-Advanced SuccessFully", 'A-', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
          this.getAllLeadDetails(this.leadId);
        } else {
          this.snackBar.open(response['status_message'], 'A-', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
        }
      },
      () => {
      });
  }

  updateLeadStatusNew(event, opt) {

    if (event?.isUserInput != false) {

      // If user clicks the current status, do nothing.
      const currentStageName = this.DealDetailsObject?.statusName || this.DealDetailsObject?.dealStage || this.DealDetailsObject?.stage;
      if (opt?.statusName && currentStageName === opt.statusName) {
        return;
      }

      // Confirm before changing status.
      const dialogRef = this.dialog.open(ConfirmYesNoDialogComponent, {
        width: '420px',
        maxWidth: '92vw',
        disableClose: true,
        panelClass: 'confirm-yes-no-dialog-panel',
        data: {
          title: 'Confirm',
          message: `Are you sure you want to change status to "${opt?.statusName || ''}"?`,
          confirmText: 'Yes',
          cancelText: 'No'
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (!confirmed) return;

        let object = {
          "entityId": this.leadId,
          "Stage": opt.statusId
        }

        this.dealsService.editLead(object, this.leadId).subscribe(
          (response) => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.DealDetailsObject.statusId = opt.statusId;
              this.DealDetailsObject.statusName = opt.statusName;
              this.DealDetailsObject.Stage = opt.statusId;
              this.DealDetailsObject.leadStatus = opt.statusId;
              this.DealDetailsObject.dealStage = opt.statusName;
              this.DealDetailsObject.stage = opt.statusName;
              this.DealDetailsObject = { ...this.DealDetailsObject };
              this.currentStatusIndex = this.filtereddropdownTypeList.findIndex(
                s => s.statusName === opt.statusName
              );
              this.snackBar.open("Status Updated SuccessFully", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
            }
          },
          () => {
          });
      });

    }
  }

  openEditPopup(field: string, label: string, type: string) {

    let value = this.DealDetailsObject[field];

    this.previousValue = value;
    if (label == 'State') {
      value = this.DealDetailsObject.isCustomizedValue?.State
    }

    if (label === 'Status Name') {
      value = this.DealDetailsObject.statusId;
    }

    if (label === 'Source Name' || label === 'Lead Source') {
      value = this.DealDetailsObject.sourceId;
    }

    if (label == 'City') {
      value = this.DealDetailsObject.isCustomizedValue?.City
    }
    if (label == 'Country') {
      value = this.DealDetailsObject.isCustomizedValue?.Country || this.DealDetailsObject.country;
    }

    if (label == 'Pincode') {
      value = this.DealDetailsObject.isCustomizedValue?.pincode
    }

    if (label == 'Address') {
      value = this.DealDetailsObject.additionalSpec?.Address
    }

    if (label == 'Lifecycle stage') {
      value = this.lifeCycleStage;
    }


    const dialogRef = this.dialog.open(FieldEditDialogComponent, {
      width: '400px',
      maxHeight: '90vh',
      data: {
        label,
        value: value,
        type,
        element: this.DealDetailsObject,
        patchValues: this.patchValues
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        const saveValue = (result && result.hasOwnProperty('value')) ? result.value : result;
        const displayValue = (result && result.hasOwnProperty('display')) ? result.display : result;

        if (value === displayValue || value === saveValue) {
          return;
        }

        this.patchResolvedValue(field, displayValue);

        if (value !== displayValue) {
          if (field.toLowerCase() === 'country') {
            this.patchResolvedValue('State', null);
            this.patchResolvedValue('City', null);
          } else if (field.toLowerCase() === 'state') {
            this.patchResolvedValue('City', null);
          }
        }

        if (result?.secondaryFormData) {
          this.patchValues = { ...this.patchValues, ...result.secondaryFormData };
          this.finalValueForm = { ...this.finalValueForm, ...result.secondaryFormData };
        }

        // If the new status has no secondary status, clear the existing secondary status
        if (result?.clearSecondaryStatus) {
          if (this.patchValues) {
            this.patchValues['secondaryLeadStatus'] = '';
            this.patchValues['SecondaryLeadStatus'] = '';
          }
          this.finalValueForm = null;
          this.DealDetailsObject['secondaryLeadStatus'] = '';
        }

        this.dynamicSaveLead(this.leadId, field, saveValue, this.DealDetailsObject, result?.clearSecondaryStatus);

      }
    });
  }



  dynamicSaveLead(leadId: any, key: string, value: any, element: any, clearSecondary: boolean = false) {
    const keyLower = (key || '').toLowerCase();
    if (keyLower === 'amount' || keyLower === 'dealvalue') {
      const paid = Number(element?.paid || element?.Paid || this.DealDetailsObject?.paid || this.DealDetailsObject?.Paid || 0);
      const newAmount = Number(value || 0);
      if (paid > 0 && newAmount < paid) {
        this.snackBar.open(`Amount cannot be less than the paid amount of ${paid}`, '×', {
          panelClass: 'error',
          verticalPosition: 'bottom',
          duration: 3000
        });
        return;
      }
    }

    let object: any = {
      entityId: leadId,
    };
    if (key.toLowerCase() === 'lifeCycleStage') {
      object['LifeCycleStage'] = value;
    }


    if (key === 'City') {
      this.DealDetailsObject.isCustomizedValue.City = value;
      object['City'] = value;
    }

    if (key === 'pincode') {
      this.DealDetailsObject.isCustomizedValue.pincode = value;
      object['pincode'] = value;
    }

    if (key.toLowerCase() === 'state') {
      this.DealDetailsObject.isCustomizedValue.State = value;
      object['State'] = value;
      object['state'] = value;

      // Cascade clear city
      if (this.DealDetailsObject.isCustomizedValue) {
        this.DealDetailsObject.isCustomizedValue.City = '';
      }
      object['City'] = '';
    }

    if (key.toLowerCase() === 'country') {
      if (!this.DealDetailsObject.isCustomizedValue) {
        this.DealDetailsObject.isCustomizedValue = {};
      }
      this.DealDetailsObject.isCustomizedValue.Country = value;
      this.DealDetailsObject.country = value;
      object['Country'] = value;
      object['country'] = value;

      // Cascade clear state and city
      this.DealDetailsObject.isCustomizedValue.State = '';
      this.DealDetailsObject.isCustomizedValue.City = '';
      object['State'] = '';
      object['City'] = '';
    }

    else if (key === 'statusName' || key === 'LeadStatus') {
      object['LeadStatus'] = value;

      if (clearSecondary) {
        // No secondary status for this lead status — explicitly clear it with empty string
        // (null is ignored by the EAV backend; empty string overwrites the existing value)
        object['secondaryLeadStatus'] = '';
      } else if (this.finalValueForm) {
        delete this.finalValueForm['LeadStatus'];
        let finalObject = { ...object, ...this.finalValueForm };
        const firstValue = this.finalValueForm.secondaryLeadStatus || Object.values(this.finalValueForm)[0];
        if (firstValue !== undefined) {
          finalObject['secondaryLeadStatus'] = firstValue;
        }
        object = finalObject;
      }
    }

    else if (key === 'sourceName') {
      object['LeadSource'] = value;
    }

    else if (key === 'ownerEmail') {
      object['Owner'] = value;
      object['OwnerName'] = element['OwnerName'];
      object['OwnerId'] = element['OwnerId'];
    }
    else if (key === 'company') {
      object['Company'] = element['Company'];
      object['CompanyId'] = element['CompanyId'];
    }
    else {
      object[key] = value;
    }

    if (key === 'email' || key === 'phoneNumber') {
      let payload = {
        Email: key === 'email' ? value : element.email,
        PhoneNumber: key === 'phoneNumber' ? value : element.phoneNumber,
        entityId: leadId
      };

      this.leadService.leadAlreadyExist(payload).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.doSave(object, leadId);
          } else {

            if (key === 'email') {

              this.DealDetailsObject.email = this.previousValue
            }

            if (key === 'phoneNumber') {
              this.DealDetailsObject.phoneNumber = this.previousValue
            }
            if (key === 'phoneNumber') {
              this.DealDetailsObject.phoneNumber = this.previousValue
            }

            this.snackBar.open(response['data']['message'], '×', {
              panelClass: 'error',
              verticalPosition: 'bottom',
              duration: 500
            });
          }
        },
        () => {

          if (key === 'email') {

            this.DealDetailsObject.email = this.previousValue
          }

          if (key === 'phoneNumber') {
            this.DealDetailsObject.phoneNumber = this.previousValue
          }
          this.snackBar.open("Error validating lead", '×', {
            panelClass: 'error',
            verticalPosition: 'bottom',
            duration: 500
          });
        }
      );
    }
    else {
      this.doSave(object, leadId);
    }
  }

  doSave(object: any, leadId: any) {
    this.dealsService.editLead(object, leadId).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

          this.getAllLeadDetails(this.leadId);
          this.getAllLeadActivity(this.leadId);

          this.snackBar.open(response['status_message'] || 'Successfully Updated', '×', {
            panelClass: 'success',
            verticalPosition: 'bottom',
            duration: 3000
          });


        } else {
          this.snackBar.open(response['status_message'], '×', {
            panelClass: 'error',
            verticalPosition: 'bottom',
            duration: 3000
          });
        }
      },
      () => {
        this.snackBar.open("Save failed", '×', {
          panelClass: 'error',
          verticalPosition: 'bottom',
          duration: 500
        });
      }
    );
  }

  adddealActivityNew(activityType: string, activityId, leadObject: any, taskType: any) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        width: '790px',
        height: '600px',
        disableClose: true,
        data: {
          "activityType": activityType,
          "type": "1",
          "leadId": this.leadId,
          "activityId": activityId,
          "leadObject": leadObject,
          "templateDisplayed": this.templateDisplayed,
          "taskSaveType": this.type,
          "taskType": taskType,

        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {

          this.getAlldealActivity(this.leadId);

        }



      });

    }
    else {
      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "activityType": activityType,
          "leadId": this.leadId,
          "activityId": activityId,
          "leadObject": leadObject,
          "type": "1",
          "templateDisplayed": this.templateDisplayed,
          "taskSaveType": this.type,
          "taskType": taskType
        },
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {

          this.getAlldealActivity(this.leadId);

        }


      });
    }

  }

  documentDownload = new FormControl('', [Validators.required]);

  @ViewChild('downloadDocument') downloadDocument: TemplateRef<any>;

  downloadDocumentPopup() {
    let dialogRef = this.dialog.open(this.downloadDocument, {
      width: '750px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
  }
  columns: any;
  filterSelectObj: any;
  documentDownloadList: any;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;



  paginationDetail = new BehaviorSubject(
    {
      length: 10,
      pageIndex: 0,
      pageSize: 10
    });


  filterActive: boolean = false;
  elements: any;
  pageList: any;

  pageSizeValue: any;

  setViewNew(view: 'Original' | 'basic'): void {
    this.activeViewNew = view;
    if (this.activeViewNew == 'basic') {
      this.getAllManageContactFields();
    }
  }


  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text || '');
    this.snackBar.open('Copied to clipboard!', 'X', {
      duration: 3000,
      verticalPosition: 'bottom',
      panelClass: ['success'],
    });
  }



  searchTextOriginal = '';
  searchTextBasic = '';

  filteredJsonRecieved: any = {};
  filteredUsedInSite: any = {};
  filteredFilterList: any = {};
  filteredAdditionalSpec: any = {};


  initializeFilteredData() {
    this.filteredJsonRecieved = this.jsonRecieved;
    this.filteredUsedInSite = this.usedInSite;
    this.filteredFilterList = this.filterList;
    this.filteredAdditionalSpec = this.additionalSpec;
  }

  // -------------------- ORIGINAL --------------------
  applySearchOriginal() {
    const text = this.searchTextOriginal.toLowerCase();
    if (!text) {
      this.filteredJsonRecieved = this.jsonRecieved;
      return;
    }
    this.filteredJsonRecieved = Object.fromEntries(
      Object.entries(this.jsonRecieved || {}).filter(([key, value]) =>
        key.toLowerCase().includes(text) ||
        ('' + value).toLowerCase().includes(text)
      )
    );
  }

  resetSearchOriginal() {
    this.searchTextOriginal = '';
    this.filteredJsonRecieved = this.jsonRecieved;
  }

  applySearchBasic() {
    const text = this.searchTextBasic.toLowerCase();
    if (!text) {
      this.filteredUsedInSite = this.usedInSite;
      this.filteredFilterList = this.filterList;
      this.filteredAdditionalSpec = this.additionalSpec;
      return;
    }

    this.filteredUsedInSite = Object.fromEntries(
      Object.entries(this.usedInSite || {}).filter(([key, value]) =>
        key.toLowerCase().includes(text) || ('' + value).toLowerCase().includes(text)
      )
    );
    this.filteredFilterList = Object.fromEntries(
      Object.entries(this.filterList || {}).filter(([key, value]) =>
        key.toLowerCase().includes(text) || ('' + value).toLowerCase().includes(text)
      )
    );
    this.filteredAdditionalSpec = Object.fromEntries(
      Object.entries(this.additionalSpec || {}).filter(([key, value]) =>
        key.toLowerCase().includes(text) || ('' + value).toLowerCase().includes(text)
      )
    );
  }

  resetSearchBasic() {
    this.searchTextBasic = '';
    this.filteredUsedInSite = this.usedInSite;
    this.filteredFilterList = this.filterList;
    this.filteredAdditionalSpec = this.additionalSpec;
  }



  globalSearchText: string = '';
  searchTabIndex: number = 0;
  isSearching: boolean = false;

  onSearchChange1() {

    this.isSearching = this.globalSearchText.trim().length > 0;


  }
  onGlobalSearchChange(value: string) {
    if (!value) {
      this.resetSearch();
      return;
    }

    const searchValue = value.toLowerCase().trim();

    // 1. First, check if the search matches a field which belongs to a specific tab
    const mappedTabName = Object.keys(this.fieldTabMapping).find(key => key.includes(searchValue));
    if (mappedTabName) {
      const targetTabName = this.fieldTabMapping[mappedTabName];
      this.switchToTabByName(targetTabName);

      // Delay slightly to allow the tab content to render before highlighting
      setTimeout(() => this.onSearchChange(), 100);
      return;
    }

    // 2. Check if it matches a Tab label/name directly
    if (this.leadTabs && this.leadTabs.length > 0) {
      const index = this.leadTabs.findIndex(tab =>
        tab.label?.toLowerCase().includes(searchValue) ||
        tab.name?.toLowerCase().includes(searchValue)
      );

      if (index !== -1) {
        this.searchTabIndex = index;
        if (this.leadDetailPageType === 5) {
          this.setActiveTab(this.leadTabs[index].name);
        }
        setTimeout(() => this.onSearchChange(), 100);
        return;
      }
    }

    // 3. Check simple tabs (Overview, My Views, etc.)
    const simpleTab = this.tabs.find(t => t.name.toLowerCase().includes(searchValue));
    if (simpleTab) {
      this.switchToTabByName(simpleTab.name);
      setTimeout(() => this.onSearchChange(), 100);
      return;
    }

    // Default: just search in current view
    this.onSearchChange();
  }

  /**
   * Helper to switch tabs across different layout types
   */
  private switchToTabByName(tabName: string) {
    // For Material Tabs style (leadDetailPageType 3, 4, etc.)
    if (this.leadTabs) {
      const index = this.leadTabs.findIndex(t => t.name.toLowerCase() === tabName.toLowerCase());
      if (index !== -1) {
        this.searchTabIndex = index;
      }
    }

    // For Sidebar style (leadDetailPageType 5)
    this.setActiveTab(tabName);

    // For other styles that use selectedTab
    this.selectedTab = tabName.toLowerCase();

    this.changeDetector.detectChanges();
  }
  onGlobalSearchBackspace() {
    const current = (this.globalSearchText || '');
    if (current.length <= 1) {
      this.globalSearchText = '';
      this.resetSearch();
    }
  }

  onSearchChange() {
    const searchValue = this.globalSearchText?.trim().toLowerCase();
    if (!searchValue) return;

    // Remove old highlights
    document.querySelectorAll('.highlight').forEach(el => el.classList.remove('highlight'));

    // Select all text nodes or relevant visible elements
    const allElements = document.querySelectorAll('label, h3, h4, p, span, td, th');
    let foundElement: HTMLElement | null = null;

    for (const el of Array.from(allElements)) {
      const element = el as HTMLElement;
      if (element.textContent?.toLowerCase().includes(searchValue)) {
        // Prefer elements that are visible and closer to being labels
        if (element.offsetParent !== null) {
          foundElement = element;
          break;
        }
      }
    }

    if (foundElement) {
      foundElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      foundElement.classList.add('highlight');

      // Keep highlights for a reasonable time or until next search
      this.highlightedElements.push(foundElement);
    }
  }

  highlightedElements: HTMLElement[] = [];

  resetSearch() {
    this.globalSearchText = '';
    this.isSearching = false;
    this.searchTabIndex = 0;
    this.highlightedElements.forEach(el => el.classList.remove('highlight'));
    this.highlightedElements = [];
  }

  private relativeTimeNewCache = new Map<string, { time: number; result: string }>();

  getRelativeTimenew(dateString: string): string {
    if (!dateString) return '';
    const now = Date.now();
    const cached = this.relativeTimeNewCache.get(dateString);
    if (cached && (now - cached.time < 5000)) {
      return cached.result;
    }

    const activityDate = new Date(dateString);
    if (isNaN(activityDate.getTime())) return '';

    const diffInSeconds = Math.floor((now - activityDate.getTime()) / 1000);
    const diffInHours = diffInSeconds / 3600;

    let result = 'Just now';
    // If the note is older than 24 hours → show date & time
    if (diffInHours >= 24) {
      const day = String(activityDate.getDate()).padStart(2, '0');
      const month = String(activityDate.getMonth() + 1).padStart(2, '0');
      const year = activityDate.getFullYear();

      const hours = String(activityDate.getHours()).padStart(2, '0');
      const minutes = String(activityDate.getMinutes()).padStart(2, '0');

      result = `${day}.${month}.${year} ${hours}:${minutes}`;
    } else {
      const intervals: { [key: string]: number } = {
        'hour': 3600,
        'minute': 60,
      };

      for (const intervalName in intervals) {
        const interval = intervals[intervalName];
        const count = Math.floor(diffInSeconds / interval);
        if (count > 0) {
          result = `${count} ${intervalName}${count > 1 ? 's' : ''} ago`;
          break;
        }
      }
    }

    this.relativeTimeNewCache.set(dateString, { time: now, result });
    return result;
  }



  addDeal(dealId: number, companyId: number) {
    this.router.navigate(['/deals/add-edit-deals', dealId, companyId]);
  }

  manageFields() {
    this.router.navigate([`/fieldDesigner/${this.leadId}`])
  }

  manageFieldsList: any;

  getAllManageContactFields() {
    this.fieldDesignerService.getAllContactFieldsDropDown()
      .subscribe(
        res => {
          this.manageFieldsList = res;
          this.mapFieldsWithValues();

        },
        () => {
        })
  }



  patchResolvedValue(fieldKey: string, value: any) {
    const normalized = this.normalizeKey(fieldKey);

    if (normalized === 'owner') {
      this.DealDetailsObject.ownerEmail = value;
      return;
    }

    const targets = [
      this.DealDetailsObject,
      this.DealDetailsObject.values,
      this.DealDetailsObject.additionalSpec,
      this.DealDetailsObject.isCustomizedValue,
      this.patchValues
    ];

    for (const target of targets) {
      if (!target) continue;

      for (const key of Object.keys(target)) {
        if (this.normalizeKey(key) === normalized) {
          target[key] = value;
        }
      }
    }
  }


  mappedGroups: any[] = [];

  mapFieldsWithValues() {
    if (!this.manageFieldsList || !this.DealDetailsObject) return;

    this.mappedGroups = this.manageFieldsList
      .filter(group => group.isActive === 1)
      .map(group => ({
        groupName: group.groupName,
        fields: group.contactFields
          .filter(field => {
            if (field.isActive !== 1) return false;

            const norm = this.normalizeKey(field.fieldKey);
            if (norm === 'state') {
              const countryValue = this.getFieldValue('Country');
              if (!countryValue) return false;
            }
            if (norm === 'city') {
              const stateValue = this.getFieldValue('State');
              if (!stateValue) return false;
            }

            const hiddenFields = ['originaldata', 'opendealamountcount', 'wondealamountcount'];
            if (hiddenFields.includes(norm)) return false;

            return true;
          })
          .map(field => {
            const rawValue = this.getFieldValue(field.fieldKey);
            const norm = this.normalizeKey(field.fieldKey);

            const readOnlyFields = ['opendealamount', 'opendealsamount', 'wondealamount', 'score'];
            let isReadOnly = field.isReadOnly;
            if (readOnlyFields.includes(norm)) {
              isReadOnly = true;
            }

            return {
              fieldId: field.fieldId,
              fieldName: field.fieldName,
              fieldKey: field.fieldKey,
              fieldType: field.fieldType,
              isReadOnly: isReadOnly,
              rawValue,
              value: this.getDisplayValue(field.fieldKey, rawValue),
              optionValues: field.optionValues,
              optionId: field.optionId,
              isRequired: field.isRequired
            };
          })
      }));
  }

  getDisplayValue(fieldKey: string, rawValue: any): any {
    if (!this.DealDetailsObject) return rawValue;

    switch (this.normalizeKey(fieldKey)) {

      case 'leadstatus':
        return this.DealDetailsObject.statusName ?? rawValue;

      case 'leadsource':
        return this.DealDetailsObject.sourceName ?? rawValue;

      case 'category':
        return this.DealDetailsObject.category ?? rawValue;

      case 'product':
        return this.DealDetailsObject.product ?? rawValue;

      default:
        return rawValue;
    }
  }



  getFieldValue(fieldKey: string): any {
    if (!this.DealDetailsObject) return null;

    const normalized = this.normalizeKey(fieldKey);

    if (normalized === 'owner') {
      return this.DealDetailsObject.ownerEmail ?? null;
    }

    const sources = [
      this.DealDetailsObject,
      this.DealDetailsObject.values,
      this.DealDetailsObject.additionalSpec,
      this.DealDetailsObject.isCustomizedValue,
      this.DealDetailsObject.jsonRecieved
    ];

    for (const source of sources) {
      if (!source) continue;

      for (const key of Object.keys(source)) {
        if (this.normalizeKey(key) === normalized) {
          return source[key];
        }
      }
    }

    return null;
  }


  private normalizeKey(key: string): string {
    return key
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/_/g, '');
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  // User list fed into collaboration components
  collaborationUsers: any[] = [];

  loadCollaborationUsers() {
    if (this.collaborationUsers.length > 0) { return; }
    try {
      this.usersService.getAllUserStatusDropDownSales().subscribe(
        (res: any) => {
          this.collaborationUsers = (res || []).map((u: any) => ({
            id: u.entityId ?? u.userId ?? u.id,
            name: u.name ?? u.userName ?? u.ownerName ?? u.email,
            email: u.email ?? u.ownerEmail ?? ''
          }));
        },
        () => { }
      );
    } catch (e) { }
  }

  get currentUserObj(): any {
    return {
      id: this.userId,
      name: localStorage.getItem('userName') ?? localStorage.getItem('email') ?? ''
    };
  }




  isNavigatingPrev: boolean = false;
  isNavigatingNext: boolean = false;

  allEntityIds: any = [];
  currentIndex: number = 0;
  allIds: any[] = [];

  // when clicking next
  goNext() {
    if (this.allIds && this.allIds.length > 0 && this.currentIndex < this.allIds.length - 1) {
      this.currentIndex++;
      this.leadId = this.allIds[this.currentIndex];
      if (!this.dialogRef) {
        this.location.replaceState(`/deals/deal-edit/${this.leadId}`);
      }
      this.isNavigatingNext = true;
      this.refreshLead(() => {
        this.isNavigatingNext = false;
      });
    }
  }

  // when clicking previous
  goPrevious() {
    if (this.allIds && this.allIds.length > 0 && this.currentIndex > 0) {
      this.currentIndex--;
      this.leadId = this.allIds[this.currentIndex];
      if (!this.dialogRef) {
        this.location.replaceState(`/deals/deal-edit/${this.leadId}`);
      }
      this.isNavigatingPrev = true;
      this.refreshLead(() => {
        this.isNavigatingPrev = false;
      });
    }
  }

  refreshLead(callback?: () => void) {
    if (this.leadId) {
      this.getcallList();
      this.getLeadNote(this.leadId);
      this.getAllEmailSend(this.leadId);
      this.getAlldealActivity(this.leadId);
      this.getAllLeadActivity(this.leadId);
      this.getAllLeadDetails(this.leadId, callback);
    } else if (callback) {
      callback();
    }
  }

  leadDetailType: any = 0;

  openLeadPanel(element: any) {
    if (window.innerWidth > 768) {
    } else {
      let option = Constant.MOBILE_Device;

      if (option == "1") {
        this.leadDetailType == 0;
      }

      if (this.leadDetailType == 0) {
        this.router.navigate([`leadDetail/${element.entityId}`])
      } else {

        const url = this.router.serializeUrl(
          this.router.createUrlTree([`leadDetail/${element.entityId}`])
        );
        const relativeUrl = url.replace(window.location.origin, '');
        window.open(relativeUrl, '_blank');

      }
    }
  }

  leadActivityList: any = [];

  leadActivityListFinal: Object;

  getAllLeadActivity(leadId) {

    this.onScrollValue = true;

    this.leadActivityService.getAllDealActivityByPageable(0, 10, 'id,desc', leadId, "2").subscribe(
      data => {

        this.totalSize = data["totalPages"];

        this.leadActivityList = data['content'];
        this.dealActivityList = data['content'];


        this.total = data['numberOfElements'];

        this.leadActivityListFinal = data;

        this.processActivities();
        this.processTasks();

        this.totalActivity = data['totalElements']


        this.init = true;

        this.pagetwo = 0;

        this.loaderService.hide();

      },
      () => {
        this.onScrollValue = false;


      })
  }
  editLead(leadId) {
    this.router.navigate([`leadDetail/${leadId}`])
    this.dialog.closeAll();
  }
}







